import { createSlice } from '@reduxjs/toolkit';

export const PharmaSlice = createSlice({
    name: "pharmaslice",
    initialState: {
      appId:33,
      actionList:[],
      actionDashboard:{
          selectedId:-1,
          actionList:[],
          actionObj:{},
          
      },
      menuList:[],
  
        partyList:[],
		partyDashboard:{
            selectedId:-1,
            showEdit:false,
            partyList:[],
            partyObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			contact:'',
			contactmobile:'',
			statusname:'',
			status:''
            },
            
			partyMgmtModalOpen:false,
			submittoapproveModalOpen:false,
			AddPartyModalOpen:false,
            
        },
        productList:[],
		productDashboard:{
            selectedId:-1,
            showEdit:false,
            productList:[],
            productObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			partyname:'',
			title:'',
			statusid:'',
			orderid:''
            },
            
			managecompositionModalOpen:false,
			editproductModalOpen:false,
			viewproductModalOpen:false,
			deleteproductModalOpen:false,
			updateproductstatusModalOpen:false,
			updateproductModalOpen:false,
			uploaddesignModalOpen:false,
			rmmanagementModalOpen:false,
			qaapprovalModalOpen:false,
			designPrintingModalOpen:false,
			selectImageModalOpen:false,
			HandleTaskModalOpen:false,
            
        },
        compositionList:[],
		compositionDashboard:{
            selectedId:-1,
            showEdit:false,
            compositionList:[],
            compositionObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			name:''
            },
            
            
        },
        productcompositionList:[],
		productcompositionDashboard:{
            selectedId:-1,
            showEdit:false,
            productcompositionList:[],
            productcompositionObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			compositionname:''
            },
            
            
        },
        poList:[],
		poDashboard:{
            selectedId:-1,
            showEdit:false,
            poList:[],
            poObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			podate:'',
			partyname:''
            },
            
			uploadPoModalOpen:false,
			viewPOModalOpen:false,
            
        },
        orderpomappingList:[],
		orderpomappingDashboard:{
            selectedId:-1,
            showEdit:false,
            orderpomappingList:[],
            orderpomappingObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			orderid:'',
			poid:''
            },
            
            
        },
        pharmaorderList:[],
		pharmaorderDashboard:{
            selectedId:-1,
            showEdit:false,
            pharmaorderList:[],
            pharmaorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			executivename:'',
			partyname:'',
			orderid:'',
			orderstatus:''
            },
            
			manageProductsModalOpen:false,
			editorderModalOpen:false,
			deleteorderModalOpen:false,
			addproductModalOpen:false,
			vieworderModalOpen:false,
			approveorderModalOpen:false,
			submitorderModalOpen:false,
			referbackModalOpen:false,
			addorderModalOpen:false,
			accountsApprovalModalOpen:false,
            
        },
        phpackagingmaterialList:[],
		phpackagingmaterialDashboard:{
            selectedId:-1,
            showEdit:false,
            phpackagingmaterialList:[],
            phpackagingmaterialObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			formid:'',
			formname:''
            },
            
            
        },
        designvendorList:[],
		designvendorDashboard:{
            selectedId:-1,
            showEdit:false,
            designvendorList:[],
            designvendorObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
            },
            
            
        },
        phproductformList:[],
		phproductformDashboard:{
            selectedId:-1,
            showEdit:false,
            phproductformList:[],
            phproductformObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
            },
            
			managePackagingMaterialModalOpen:false,
            
        },
        phproductList:[],
		phproductDashboard:{
            selectedId:-1,
            showEdit:false,
            phproductList:[],
            phproductObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			partyname:'',
			title:'',
			status:''
            },
            
            
        },
        phproductstatusList:[],
		phproductstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            phproductstatusList:[],
            phproductstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        phproductshapeList:[],
		phproductshapeDashboard:{
            selectedId:-1,
            showEdit:false,
            phproductshapeList:[],
            phproductshapeObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			formid:'',
			formname:''
            },
            
            
        },
        phdesignList:[],
		phdesignDashboard:{
            selectedId:-1,
            showEdit:false,
            phdesignList:[],
            phdesignObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        productassetList:[],
		productassetDashboard:{
            selectedId:-1,
            showEdit:false,
            productassetList:[],
            productassetObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			designvendorname:''
            },
            
			viewModalOpen:false,
			AnnotateAssetModalOpen:false,
            
        },
        rmunitList:[],
		rmunitDashboard:{
            selectedId:-1,
            showEdit:false,
            rmunitList:[],
            rmunitObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        rawmaterialList:[],
		rawmaterialDashboard:{
            selectedId:-1,
            showEdit:false,
            rawmaterialList:[],
            rawmaterialObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        productrawList:[],
		productrawDashboard:{
            selectedId:-1,
            showEdit:false,
            productrawList:[],
            productrawObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			rmname:''
            },
            
            
        },
        rawdemandList:[],
		rawdemandDashboard:{
            selectedId:-1,
            showEdit:false,
            rawdemandList:[],
            rawdemandObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			status:'',
			vendorname:''
            },
            
			quotationmgmtModalOpen:false,
            
        },
        productrawtorawdemandList:[],
		productrawtorawdemandDashboard:{
            selectedId:-1,
            showEdit:false,
            productrawtorawdemandList:[],
            productrawtorawdemandObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        rmvendorList:[],
		rmvendorDashboard:{
            selectedId:-1,
            showEdit:false,
            rmvendorList:[],
            rmvendorObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
            },
            
            
        },
        rmvendorquotationList:[],
		rmvendorquotationDashboard:{
            selectedId:-1,
            showEdit:false,
            rmvendorquotationList:[],
            rmvendorquotationObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			rmvendorname:''
            },
            
            
        },
        compositiontemplateList:[],
		compositiontemplateDashboard:{
            selectedId:-1,
            showEdit:false,
            compositiontemplateList:[],
            compositiontemplateObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			compositionMgmtModalOpen:false,
            
        },
        ctitemList:[],
		ctitemDashboard:{
            selectedId:-1,
            showEdit:false,
            ctitemList:[],
            ctitemObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        packagingsizeList:[],
		packagingsizeDashboard:{
            selectedId:-1,
            showEdit:false,
            packagingsizeList:[],
            packagingsizeObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			formid:''
            },
            
            
        },
        pharmasetList:[],
		pharmasetDashboard:{
            selectedId:-1,
            showEdit:false,
            pharmasetList:[],
            pharmasetObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			formid:'',
			formname:''
            },
            
            
        },
        partystatusList:[],
		partystatusDashboard:{
            selectedId:-1,
            showEdit:false,
            partystatusList:[],
            partystatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        assetcommentsList:[],
		assetcommentsDashboard:{
            selectedId:-1,
            showEdit:false,
            assetcommentsList:[],
            assetcommentsObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        saltList:[],
		saltDashboard:{
            selectedId:-1,
            showEdit:false,
            saltList:[],
            saltObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			manageSaltModalOpen:false,
            
        },
        salt2compList:[],
		salt2compDashboard:{
            selectedId:-1,
            showEdit:false,
            salt2compList:[],
            salt2compObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        pmorderList:[],
		pmorderDashboard:{
            selectedId:-1,
            showEdit:false,
            pmorderList:[],
            pmorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        rmorderList:[],
		rmorderDashboard:{
            selectedId:-1,
            showEdit:false,
            rmorderList:[],
            rmorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        remarkList:[],
		remarkDashboard:{
            selectedId:-1,
            showEdit:false,
            remarkList:[],
            remarkObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        gstList:[],
		gstDashboard:{
            selectedId:-1,
            showEdit:false,
            gstList:[],
            gstObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        dmunitList:[],
		dmunitDashboard:{
            selectedId:-1,
            showEdit:false,
            dmunitList:[],
            dmunitObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        foodcompositionList:[],
		foodcompositionDashboard:{
            selectedId:-1,
            showEdit:false,
            foodcompositionList:[],
            foodcompositionObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			AddFoodCompModalOpen:false,
            
        },
        tagList:[],
		tagDashboard:{
            selectedId:-1,
            showEdit:false,
            tagList:[],
            tagObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			type:''
            },
            
            
        },
        biltyList:[],
		biltyDashboard:{
            selectedId:-1,
            showEdit:false,
            biltyList:[],
            biltyObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			AddBiltyModalOpen:false,
			ManageBiltyModalOpen:false,
            
        },
        biltytoproductmapList:[],
		biltytoproductmapDashboard:{
            selectedId:-1,
            showEdit:false,
            biltytoproductmapList:[],
            biltytoproductmapObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
    },
    reducers: {
        
        setActionList: (state, action) =>{
            state.actionList=action.payload;
            state.actionDashboard.actionList=action.payload;
        },
        setSelectedActionId: (state, action)=>{
            state.actionDashboard.selectedId=action.payload;

            state.actionDashboard.actionObj = state.actionList[
                state.actionList.findIndex(actionObj=>actionObj.id===parseInt(action.payload))
            ];
        },

        
        /* Party Reducer methods */
        setPartySorting: (state, action)=>{
            state.partyDashboard.sorting=action.payload;
        },
        setPartyFilterCriteria : (state, action)=>{
            state.partyDashboard.filterCriteria=action.payload;
        },
        setShowEditForParty: (state,action)=>{
            state.partyDashboard.showEdit=action.payload;
            
			state.partyDashboard.partyMgmtModalOpen=false;
			state.partyDashboard.submittoapproveModalOpen=false;
			state.partyDashboard.AddPartyModalOpen=false;
        },
        addPartyObj: (state, action)=>{
            state.partyList.unshift(action.payload);
            state.partyDashboard.partyList.unshift(action.payload);

            state.partyDashboard.partyObj=action.payload;
            state.partyDashboard.selectedId=action.payload.id;
        },
        updatePartyObj: (state, action)=>{
            let index = state.partyList.map(partyObj=>partyObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.partyList[index]=action.payload;
            }

            index = state.partyDashboard.partyList.map(partyObj=>partyObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.partyDashboard.partyList[index]=action.payload;
            }
            if (state.partyDashboard.partyObj!==null){
                state.partyDashboard.partyObj = action.payload;
            }
        },
        deletePartyObj: (state, action)=>{
            state.partyList.splice(state.partyList.findIndex(a => a.id === action.payload) , 1);
            state.partyDashboard.partyList.splice(state.partyDashboard.partyList.findIndex(a => a.id === action.payload) , 1);
            state.partyDashboard.productObj={}
            state.partyDashboard.selectedId=-1
        },
        setSelectedPartyId: (state, action)=>{
            if (action.payload!==-1){
                state.partyDashboard.selectedId=action.payload;
                state.partyDashboard.partyObj = state.partyList[
                    state.partyList.findIndex(partyObj=>partyObj.id===parseInt(action.payload))
            ];
            } else {
                state.partyDashboard.selectedId=action.payload;
                state.partyDashboard.partyObj ={}
            }
        },
        setPartyList: (state, action) =>{
            state.partyList=action.payload;
            state.partyDashboard.partyList=action.payload;
        },
        setPartyDashboardPartyList: (state, action) =>{
            state.partyDashboard.partyList=action.payload;
        },
      
        setPartyPartyMgmtModal:(state,action)=>{
          state.partyDashboard.partyMgmtModalOpen=action.payload;
        },
      
        setPartySubmittoapproveModal:(state,action)=>{
          state.partyDashboard.submittoapproveModalOpen=action.payload;
        },
      
        setPartyAddPartyModal:(state,action)=>{
          state.partyDashboard.AddPartyModalOpen=action.payload;
        },
        /* Product Reducer methods */
        setProductSorting: (state, action)=>{
            state.productDashboard.sorting=action.payload;
        },
        setProductFilterCriteria : (state, action)=>{
            state.productDashboard.filterCriteria=action.payload;
        },
        setShowEditForProduct: (state,action)=>{
            state.productDashboard.showEdit=action.payload;
            
			state.productDashboard.managecompositionModalOpen=false;
			state.productDashboard.editproductModalOpen=false;
			state.productDashboard.viewproductModalOpen=false;
			state.productDashboard.deleteproductModalOpen=false;
			state.productDashboard.updateproductstatusModalOpen=false;
			state.productDashboard.updateproductModalOpen=false;
			state.productDashboard.uploaddesignModalOpen=false;
			state.productDashboard.rmmanagementModalOpen=false;
			state.productDashboard.qaapprovalModalOpen=false;
			state.productDashboard.designPrintingModalOpen=false;
			state.productDashboard.selectImageModalOpen=false;
//			state.productDashboard.HandleTaskModalOpen=false;
        },
        addProductObj: (state, action)=>{
            state.productList.unshift(action.payload);
            state.productDashboard.productList.unshift(action.payload);

            state.productDashboard.productObj=action.payload;
            state.productDashboard.selectedId=action.payload.id;
        },
        updateProductObj: (state, action)=>{
            let index = state.productList.map(productObj=>productObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productList[index]=action.payload;
            }

            index = state.productDashboard.productList.map(productObj=>productObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productDashboard.productList[index]=action.payload;
            }
            if (state.productDashboard.productObj!==null){
                state.productDashboard.productObj = action.payload;
            }
        },
        deleteProductObj: (state, action)=>{
            state.productList.splice(state.productList.findIndex(a => a.id === action.payload) , 1);
            state.productDashboard.productList.splice(state.productDashboard.productList.findIndex(a => a.id === action.payload) , 1);
            state.productDashboard.productObj={}
            state.productDashboard.selectedId=-1
        },
        setSelectedProductId: (state, action)=>{
            if (action.payload!==-1){
                state.productDashboard.selectedId=action.payload;
                state.productDashboard.productObj = state.productList[
                    state.productList.findIndex(productObj=>productObj.id===parseInt(action.payload))
            ];
            } else {
                state.productDashboard.selectedId=action.payload;
                state.productDashboard.productObj ={}
            }
        },
        setProductList: (state, action) =>{
            state.productList=action.payload;
            state.productDashboard.productList=action.payload;
        },
        setProductDashboardProductList: (state, action) =>{
            state.productDashboard.productList=action.payload;
        },
      
        setProductManagecompositionModal:(state,action)=>{
          state.productDashboard.managecompositionModalOpen=action.payload;
        },
      
        setProductEditproductModal:(state,action)=>{
          state.productDashboard.editproductModalOpen=action.payload;
        },
      
        setProductViewproductModal:(state,action)=>{
          state.productDashboard.viewproductModalOpen=action.payload;
        },
      
        setProductDeleteproductModal:(state,action)=>{
          state.productDashboard.deleteproductModalOpen=action.payload;
        },
      
        setProductUpdateproductstatusModal:(state,action)=>{
          state.productDashboard.updateproductstatusModalOpen=action.payload;
        },
      
        setProductUpdateproductModal:(state,action)=>{
          state.productDashboard.updateproductModalOpen=action.payload;
        },
      
        setProductUploaddesignModal:(state,action)=>{
          state.productDashboard.uploaddesignModalOpen=action.payload;
        },
      
        setProductRmmanagementModal:(state,action)=>{
          state.productDashboard.rmmanagementModalOpen=action.payload;
        },
      
        setProductQaapprovalModal:(state,action)=>{
          state.productDashboard.qaapprovalModalOpen=action.payload;
        },
      
        setProductDesignPrintingModal:(state,action)=>{
          state.productDashboard.designPrintingModalOpen=action.payload;
        },
      
        setProductSelectImageModal:(state,action)=>{
          state.productDashboard.selectImageModalOpen=action.payload;
        },
      
        setProductHandleTaskModal:(state,action)=>{
          state.productDashboard.HandleTaskModalOpen=action.payload;
        },
        /* Composition Reducer methods */
        setCompositionSorting: (state, action)=>{
            state.compositionDashboard.sorting=action.payload;
        },
        setCompositionFilterCriteria : (state, action)=>{
            state.compositionDashboard.filterCriteria=action.payload;
        },
        setShowEditForComposition: (state,action)=>{
            state.compositionDashboard.showEdit=action.payload;
            
        },
        addCompositionObj: (state, action)=>{
            state.compositionList.unshift(action.payload);
            state.compositionDashboard.compositionList.unshift(action.payload);

            state.compositionDashboard.compositionObj=action.payload;
            state.compositionDashboard.selectedId=action.payload.id;
        },
        updateCompositionObj: (state, action)=>{
            let index = state.compositionList.map(compositionObj=>compositionObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.compositionList[index]=action.payload;
            }

            index = state.compositionDashboard.compositionList.map(compositionObj=>compositionObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.compositionDashboard.compositionList[index]=action.payload;
            }
            if (state.compositionDashboard.compositionObj!==null){
                state.compositionDashboard.compositionObj = action.payload;
            }
        },
        deleteCompositionObj: (state, action)=>{
            state.compositionList.splice(state.compositionList.findIndex(a => a.id === action.payload) , 1);
            state.compositionDashboard.compositionList.splice(state.compositionDashboard.compositionList.findIndex(a => a.id === action.payload) , 1);
            state.compositionDashboard.productObj={}
            state.compositionDashboard.selectedId=-1
        },
        setSelectedCompositionId: (state, action)=>{
            if (action.payload!==-1){
                state.compositionDashboard.selectedId=action.payload;
                state.compositionDashboard.compositionObj = state.compositionList[
                    state.compositionList.findIndex(compositionObj=>compositionObj.id===parseInt(action.payload))
            ];
            } else {
                state.compositionDashboard.selectedId=action.payload;
                state.compositionDashboard.compositionObj ={}
            }
        },
        setCompositionList: (state, action) =>{
            state.compositionList=action.payload;
            state.compositionDashboard.compositionList=action.payload;
        },
        setCompositionDashboardCompositionList: (state, action) =>{
            state.compositionDashboard.compositionList=action.payload;
        },
        /* Productcomposition Reducer methods */
        setProductcompositionSorting: (state, action)=>{
            state.productcompositionDashboard.sorting=action.payload;
        },
        setProductcompositionFilterCriteria : (state, action)=>{
            state.productcompositionDashboard.filterCriteria=action.payload;
        },
        setShowEditForProductcomposition: (state,action)=>{
            state.productcompositionDashboard.showEdit=action.payload;
            
        },
        addProductcompositionObj: (state, action)=>{
            state.productcompositionList.unshift(action.payload);
            state.productcompositionDashboard.productcompositionList.unshift(action.payload);

            state.productcompositionDashboard.productcompositionObj=action.payload;
            state.productcompositionDashboard.selectedId=action.payload.id;
        },
        updateProductcompositionObj: (state, action)=>{
            let index = state.productcompositionList.map(productcompositionObj=>productcompositionObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productcompositionList[index]=action.payload;
            }

            index = state.productcompositionDashboard.productcompositionList.map(productcompositionObj=>productcompositionObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productcompositionDashboard.productcompositionList[index]=action.payload;
            }
            if (state.productcompositionDashboard.productcompositionObj!==null){
                state.productcompositionDashboard.productcompositionObj = action.payload;
            }
        },
        deleteProductcompositionObj: (state, action)=>{
            state.productcompositionList.splice(state.productcompositionList.findIndex(a => a.id === action.payload) , 1);
            state.productcompositionDashboard.productcompositionList.splice(state.productcompositionDashboard.productcompositionList.findIndex(a => a.id === action.payload) , 1);
            state.productcompositionDashboard.productObj={}
            state.productcompositionDashboard.selectedId=-1
        },
        setSelectedProductcompositionId: (state, action)=>{
            if (action.payload!==-1){
                state.productcompositionDashboard.selectedId=action.payload;
                state.productcompositionDashboard.productcompositionObj = state.productcompositionList[
                    state.productcompositionList.findIndex(productcompositionObj=>productcompositionObj.id===parseInt(action.payload))
            ];
            } else {
                state.productcompositionDashboard.selectedId=action.payload;
                state.productcompositionDashboard.productcompositionObj ={}
            }
        },
        setProductcompositionList: (state, action) =>{
            state.productcompositionList=action.payload;
            state.productcompositionDashboard.productcompositionList=action.payload;
        },
        setProductcompositionDashboardProductcompositionList: (state, action) =>{
            state.productcompositionDashboard.productcompositionList=action.payload;
        },
        /* Po Reducer methods */
        setPoSorting: (state, action)=>{
            state.poDashboard.sorting=action.payload;
        },
        setPoFilterCriteria : (state, action)=>{
            state.poDashboard.filterCriteria=action.payload;
        },
        setShowEditForPo: (state,action)=>{
            state.poDashboard.showEdit=action.payload;
            
			state.poDashboard.uploadPoModalOpen=false;
			state.poDashboard.viewPOModalOpen=false;
        },
        addPoObj: (state, action)=>{
            state.poList.unshift(action.payload);
            state.poDashboard.poList.unshift(action.payload);

            state.poDashboard.poObj=action.payload;
            state.poDashboard.selectedId=action.payload.id;
        },
        updatePoObj: (state, action)=>{
            let index = state.poList.map(poObj=>poObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.poList[index]=action.payload;
            }

            index = state.poDashboard.poList.map(poObj=>poObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.poDashboard.poList[index]=action.payload;
            }
            if (state.poDashboard.poObj!==null){
                state.poDashboard.poObj = action.payload;
            }
        },
        deletePoObj: (state, action)=>{
            state.poList.splice(state.poList.findIndex(a => a.id === action.payload) , 1);
            state.poDashboard.poList.splice(state.poDashboard.poList.findIndex(a => a.id === action.payload) , 1);
            state.poDashboard.productObj={}
            state.poDashboard.selectedId=-1
        },
        setSelectedPoId: (state, action)=>{
            if (action.payload!==-1){
                state.poDashboard.selectedId=action.payload;
                state.poDashboard.poObj = state.poList[
                    state.poList.findIndex(poObj=>poObj.id===parseInt(action.payload))
            ];
            } else {
                state.poDashboard.selectedId=action.payload;
                state.poDashboard.poObj ={}
            }
        },
        setPoList: (state, action) =>{
            state.poList=action.payload;
            state.poDashboard.poList=action.payload;
        },
        setPoDashboardPoList: (state, action) =>{
            state.poDashboard.poList=action.payload;
        },
      
        setPoUploadPoModal:(state,action)=>{
          state.poDashboard.uploadPoModalOpen=action.payload;
        },
      
        setPoViewPOModal:(state,action)=>{
          state.poDashboard.viewPOModalOpen=action.payload;
        },
        /* Orderpomapping Reducer methods */
        setOrderpomappingSorting: (state, action)=>{
            state.orderpomappingDashboard.sorting=action.payload;
        },
        setOrderpomappingFilterCriteria : (state, action)=>{
            state.orderpomappingDashboard.filterCriteria=action.payload;
        },
        setShowEditForOrderpomapping: (state,action)=>{
            state.orderpomappingDashboard.showEdit=action.payload;
            
        },
        addOrderpomappingObj: (state, action)=>{
            state.orderpomappingList.unshift(action.payload);
            state.orderpomappingDashboard.orderpomappingList.unshift(action.payload);

            state.orderpomappingDashboard.orderpomappingObj=action.payload;
            state.orderpomappingDashboard.selectedId=action.payload.id;
        },
        updateOrderpomappingObj: (state, action)=>{
            let index = state.orderpomappingList.map(orderpomappingObj=>orderpomappingObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.orderpomappingList[index]=action.payload;
            }

            index = state.orderpomappingDashboard.orderpomappingList.map(orderpomappingObj=>orderpomappingObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.orderpomappingDashboard.orderpomappingList[index]=action.payload;
            }
            if (state.orderpomappingDashboard.orderpomappingObj!==null){
                state.orderpomappingDashboard.orderpomappingObj = action.payload;
            }
        },
        deleteOrderpomappingObj: (state, action)=>{
            state.orderpomappingList.splice(state.orderpomappingList.findIndex(a => a.id === action.payload) , 1);
            state.orderpomappingDashboard.orderpomappingList.splice(state.orderpomappingDashboard.orderpomappingList.findIndex(a => a.id === action.payload) , 1);
            state.orderpomappingDashboard.productObj={}
            state.orderpomappingDashboard.selectedId=-1
        },
        setSelectedOrderpomappingId: (state, action)=>{
            if (action.payload!==-1){
                state.orderpomappingDashboard.selectedId=action.payload;
                state.orderpomappingDashboard.orderpomappingObj = state.orderpomappingList[
                    state.orderpomappingList.findIndex(orderpomappingObj=>orderpomappingObj.id===parseInt(action.payload))
            ];
            } else {
                state.orderpomappingDashboard.selectedId=action.payload;
                state.orderpomappingDashboard.orderpomappingObj ={}
            }
        },
        setOrderpomappingList: (state, action) =>{
            state.orderpomappingList=action.payload;
            state.orderpomappingDashboard.orderpomappingList=action.payload;
        },
        setOrderpomappingDashboardOrderpomappingList: (state, action) =>{
            state.orderpomappingDashboard.orderpomappingList=action.payload;
        },
        /* Pharmaorder Reducer methods */
        setPharmaorderSorting: (state, action)=>{
            state.pharmaorderDashboard.sorting=action.payload;
        },
        setPharmaorderFilterCriteria : (state, action)=>{
            state.pharmaorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForPharmaorder: (state,action)=>{
            state.pharmaorderDashboard.showEdit=action.payload;
            
			state.pharmaorderDashboard.manageProductsModalOpen=false;
			state.pharmaorderDashboard.editorderModalOpen=false;
			state.pharmaorderDashboard.deleteorderModalOpen=false;
			state.pharmaorderDashboard.addproductModalOpen=false;
			state.pharmaorderDashboard.vieworderModalOpen=false;
			state.pharmaorderDashboard.approveorderModalOpen=false;
			state.pharmaorderDashboard.submitorderModalOpen=false;
			state.pharmaorderDashboard.referbackModalOpen=false;
			state.pharmaorderDashboard.addorderModalOpen=false;
			state.pharmaorderDashboard.accountsApprovalModalOpen=false;
        },
        addPharmaorderObj: (state, action)=>{
            state.pharmaorderList.unshift(action.payload);
            state.pharmaorderDashboard.pharmaorderList.unshift(action.payload);

            state.pharmaorderDashboard.pharmaorderObj=action.payload;
            state.pharmaorderDashboard.selectedId=action.payload.id;
        },
        updatePharmaorderObj: (state, action)=>{
            let index = state.pharmaorderList.map(pharmaorderObj=>pharmaorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.pharmaorderList[index]=action.payload;
            }

            index = state.pharmaorderDashboard.pharmaorderList.map(pharmaorderObj=>pharmaorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.pharmaorderDashboard.pharmaorderList[index]=action.payload;
            }
            if (state.pharmaorderDashboard.pharmaorderObj!==null){
                state.pharmaorderDashboard.pharmaorderObj = action.payload;
            }
        },
        deletePharmaorderObj: (state, action)=>{
            state.pharmaorderList.splice(state.pharmaorderList.findIndex(a => a.id === action.payload) , 1);
            state.pharmaorderDashboard.pharmaorderList.splice(state.pharmaorderDashboard.pharmaorderList.findIndex(a => a.id === action.payload) , 1);
            state.pharmaorderDashboard.productObj={}
            state.pharmaorderDashboard.selectedId=-1
        },
        setSelectedPharmaorderId: (state, action)=>{
            if (action.payload!==-1){
                state.pharmaorderDashboard.selectedId=action.payload;
                state.pharmaorderDashboard.pharmaorderObj = state.pharmaorderList[
                    state.pharmaorderList.findIndex(pharmaorderObj=>pharmaorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.pharmaorderDashboard.selectedId=action.payload;
                state.pharmaorderDashboard.pharmaorderObj ={}
            }
        },
        setPharmaorderList: (state, action) =>{
            state.pharmaorderList=action.payload;
            state.pharmaorderDashboard.pharmaorderList=action.payload;
        },
        setPharmaorderDashboardPharmaorderList: (state, action) =>{
            state.pharmaorderDashboard.pharmaorderList=action.payload;
        },
      
        setPharmaorderManageProductsModal:(state,action)=>{
          state.pharmaorderDashboard.manageProductsModalOpen=action.payload;
        },
      
        setPharmaorderEditorderModal:(state,action)=>{
          state.pharmaorderDashboard.editorderModalOpen=action.payload;
        },
      
        setPharmaorderDeleteorderModal:(state,action)=>{
          state.pharmaorderDashboard.deleteorderModalOpen=action.payload;
        },
      
        setPharmaorderAddproductModal:(state,action)=>{
          state.pharmaorderDashboard.addproductModalOpen=action.payload;
        },
      
        setPharmaorderVieworderModal:(state,action)=>{
          state.pharmaorderDashboard.vieworderModalOpen=action.payload;
        },
      
        setPharmaorderApproveorderModal:(state,action)=>{
          state.pharmaorderDashboard.approveorderModalOpen=action.payload;
        },
      
        setPharmaorderSubmitorderModal:(state,action)=>{
          state.pharmaorderDashboard.submitorderModalOpen=action.payload;
        },
      
        setPharmaorderReferbackModal:(state,action)=>{
          state.pharmaorderDashboard.referbackModalOpen=action.payload;
        },
      
        setPharmaorderAddorderModal:(state,action)=>{
          state.pharmaorderDashboard.addorderModalOpen=action.payload;
        },
      
        setPharmaorderAccountsApprovalModal:(state,action)=>{
          state.pharmaorderDashboard.accountsApprovalModalOpen=action.payload;
        },
        /* Phpackagingmaterial Reducer methods */
        setPhpackagingmaterialSorting: (state, action)=>{
            state.phpackagingmaterialDashboard.sorting=action.payload;
        },
        setPhpackagingmaterialFilterCriteria : (state, action)=>{
            state.phpackagingmaterialDashboard.filterCriteria=action.payload;
        },
        setShowEditForPhpackagingmaterial: (state,action)=>{
            state.phpackagingmaterialDashboard.showEdit=action.payload;
            
        },
        addPhpackagingmaterialObj: (state, action)=>{
            state.phpackagingmaterialList.unshift(action.payload);
            state.phpackagingmaterialDashboard.phpackagingmaterialList.unshift(action.payload);

            state.phpackagingmaterialDashboard.phpackagingmaterialObj=action.payload;
            state.phpackagingmaterialDashboard.selectedId=action.payload.id;
        },
        updatePhpackagingmaterialObj: (state, action)=>{
            let index = state.phpackagingmaterialList.map(phpackagingmaterialObj=>phpackagingmaterialObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phpackagingmaterialList[index]=action.payload;
            }

            index = state.phpackagingmaterialDashboard.phpackagingmaterialList.map(phpackagingmaterialObj=>phpackagingmaterialObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phpackagingmaterialDashboard.phpackagingmaterialList[index]=action.payload;
            }
            if (state.phpackagingmaterialDashboard.phpackagingmaterialObj!==null){
                state.phpackagingmaterialDashboard.phpackagingmaterialObj = action.payload;
            }
        },
        deletePhpackagingmaterialObj: (state, action)=>{
            state.phpackagingmaterialList.splice(state.phpackagingmaterialList.findIndex(a => a.id === action.payload) , 1);
            state.phpackagingmaterialDashboard.phpackagingmaterialList.splice(state.phpackagingmaterialDashboard.phpackagingmaterialList.findIndex(a => a.id === action.payload) , 1);
            state.phpackagingmaterialDashboard.productObj={}
            state.phpackagingmaterialDashboard.selectedId=-1
        },
        setSelectedPhpackagingmaterialId: (state, action)=>{
            if (action.payload!==-1){
                state.phpackagingmaterialDashboard.selectedId=action.payload;
                state.phpackagingmaterialDashboard.phpackagingmaterialObj = state.phpackagingmaterialList[
                    state.phpackagingmaterialList.findIndex(phpackagingmaterialObj=>phpackagingmaterialObj.id===parseInt(action.payload))
            ];
            } else {
                state.phpackagingmaterialDashboard.selectedId=action.payload;
                state.phpackagingmaterialDashboard.phpackagingmaterialObj ={}
            }
        },
        setPhpackagingmaterialList: (state, action) =>{
            state.phpackagingmaterialList=action.payload;
            state.phpackagingmaterialDashboard.phpackagingmaterialList=action.payload;
        },
        setPhpackagingmaterialDashboardPhpackagingmaterialList: (state, action) =>{
            state.phpackagingmaterialDashboard.phpackagingmaterialList=action.payload;
        },
        /* Designvendor Reducer methods */
        setDesignvendorSorting: (state, action)=>{
            state.designvendorDashboard.sorting=action.payload;
        },
        setDesignvendorFilterCriteria : (state, action)=>{
            state.designvendorDashboard.filterCriteria=action.payload;
        },
        setShowEditForDesignvendor: (state,action)=>{
            state.designvendorDashboard.showEdit=action.payload;
            
        },
        addDesignvendorObj: (state, action)=>{
            state.designvendorList.unshift(action.payload);
            state.designvendorDashboard.designvendorList.unshift(action.payload);

            state.designvendorDashboard.designvendorObj=action.payload;
            state.designvendorDashboard.selectedId=action.payload.id;
        },
        updateDesignvendorObj: (state, action)=>{
            let index = state.designvendorList.map(designvendorObj=>designvendorObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.designvendorList[index]=action.payload;
            }

            index = state.designvendorDashboard.designvendorList.map(designvendorObj=>designvendorObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.designvendorDashboard.designvendorList[index]=action.payload;
            }
            if (state.designvendorDashboard.designvendorObj!==null){
                state.designvendorDashboard.designvendorObj = action.payload;
            }
        },
        deleteDesignvendorObj: (state, action)=>{
            state.designvendorList.splice(state.designvendorList.findIndex(a => a.id === action.payload) , 1);
            state.designvendorDashboard.designvendorList.splice(state.designvendorDashboard.designvendorList.findIndex(a => a.id === action.payload) , 1);
            state.designvendorDashboard.productObj={}
            state.designvendorDashboard.selectedId=-1
        },
        setSelectedDesignvendorId: (state, action)=>{
            if (action.payload!==-1){
                state.designvendorDashboard.selectedId=action.payload;
                state.designvendorDashboard.designvendorObj = state.designvendorList[
                    state.designvendorList.findIndex(designvendorObj=>designvendorObj.id===parseInt(action.payload))
            ];
            } else {
                state.designvendorDashboard.selectedId=action.payload;
                state.designvendorDashboard.designvendorObj ={}
            }
        },
        setDesignvendorList: (state, action) =>{
            state.designvendorList=action.payload;
            state.designvendorDashboard.designvendorList=action.payload;
        },
        setDesignvendorDashboardDesignvendorList: (state, action) =>{
            state.designvendorDashboard.designvendorList=action.payload;
        },
        /* Phproductform Reducer methods */
        setPhproductformSorting: (state, action)=>{
            state.phproductformDashboard.sorting=action.payload;
        },
        setPhproductformFilterCriteria : (state, action)=>{
            state.phproductformDashboard.filterCriteria=action.payload;
        },
        setShowEditForPhproductform: (state,action)=>{
            state.phproductformDashboard.showEdit=action.payload;
            
			state.phproductformDashboard.managePackagingMaterialModalOpen=false;
        },
        addPhproductformObj: (state, action)=>{
            state.phproductformList.unshift(action.payload);
            state.phproductformDashboard.phproductformList.unshift(action.payload);

            state.phproductformDashboard.phproductformObj=action.payload;
            state.phproductformDashboard.selectedId=action.payload.id;
        },
        updatePhproductformObj: (state, action)=>{
            let index = state.phproductformList.map(phproductformObj=>phproductformObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductformList[index]=action.payload;
            }

            index = state.phproductformDashboard.phproductformList.map(phproductformObj=>phproductformObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductformDashboard.phproductformList[index]=action.payload;
            }
            if (state.phproductformDashboard.phproductformObj!==null){
                state.phproductformDashboard.phproductformObj = action.payload;
            }
        },
        deletePhproductformObj: (state, action)=>{
            state.phproductformList.splice(state.phproductformList.findIndex(a => a.id === action.payload) , 1);
            state.phproductformDashboard.phproductformList.splice(state.phproductformDashboard.phproductformList.findIndex(a => a.id === action.payload) , 1);
            state.phproductformDashboard.productObj={}
            state.phproductformDashboard.selectedId=-1
        },
        setSelectedPhproductformId: (state, action)=>{
            if (action.payload!==-1){
                state.phproductformDashboard.selectedId=action.payload;
                state.phproductformDashboard.phproductformObj = state.phproductformList[
                    state.phproductformList.findIndex(phproductformObj=>phproductformObj.id===parseInt(action.payload))
            ];
            } else {
                state.phproductformDashboard.selectedId=action.payload;
                state.phproductformDashboard.phproductformObj ={}
            }
        },
        setPhproductformList: (state, action) =>{
            state.phproductformList=action.payload;
            state.phproductformDashboard.phproductformList=action.payload;
        },
        setPhproductformDashboardPhproductformList: (state, action) =>{
            state.phproductformDashboard.phproductformList=action.payload;
        },
      
        setPhproductformManagePackagingMaterialModal:(state,action)=>{
          state.phproductformDashboard.managePackagingMaterialModalOpen=action.payload;
        },
        /* Phproduct Reducer methods */
        setPhproductSorting: (state, action)=>{
            state.phproductDashboard.sorting=action.payload;
        },
        setPhproductFilterCriteria : (state, action)=>{
            state.phproductDashboard.filterCriteria=action.payload;
        },
        setShowEditForPhproduct: (state,action)=>{
            state.phproductDashboard.showEdit=action.payload;
            
        },
        addPhproductObj: (state, action)=>{
            state.phproductList.unshift(action.payload);
            state.phproductDashboard.phproductList.unshift(action.payload);

            state.phproductDashboard.phproductObj=action.payload;
            state.phproductDashboard.selectedId=action.payload.id;
        },
        updatePhproductObj: (state, action)=>{
            let index = state.phproductList.map(phproductObj=>phproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductList[index]=action.payload;
            }

            index = state.phproductDashboard.phproductList.map(phproductObj=>phproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductDashboard.phproductList[index]=action.payload;
            }
            if (state.phproductDashboard.phproductObj!==null){
                state.phproductDashboard.phproductObj = action.payload;
            }
        },
        deletePhproductObj: (state, action)=>{
            state.phproductList.splice(state.phproductList.findIndex(a => a.id === action.payload) , 1);
            state.phproductDashboard.phproductList.splice(state.phproductDashboard.phproductList.findIndex(a => a.id === action.payload) , 1);
            state.phproductDashboard.productObj={}
            state.phproductDashboard.selectedId=-1
        },
        setSelectedPhproductId: (state, action)=>{
            if (action.payload!==-1){
                state.phproductDashboard.selectedId=action.payload;
                state.phproductDashboard.phproductObj = state.phproductList[
                    state.phproductList.findIndex(phproductObj=>phproductObj.id===parseInt(action.payload))
            ];
            } else {
                state.phproductDashboard.selectedId=action.payload;
                state.phproductDashboard.phproductObj ={}
            }
        },
        setPhproductList: (state, action) =>{
            state.phproductList=action.payload;
            state.phproductDashboard.phproductList=action.payload;
        },
        setPhproductDashboardPhproductList: (state, action) =>{
            state.phproductDashboard.phproductList=action.payload;
        },
        /* Phproductstatus Reducer methods */
        setPhproductstatusSorting: (state, action)=>{
            state.phproductstatusDashboard.sorting=action.payload;
        },
        setPhproductstatusFilterCriteria : (state, action)=>{
            state.phproductstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForPhproductstatus: (state,action)=>{
            state.phproductstatusDashboard.showEdit=action.payload;
            
        },
        addPhproductstatusObj: (state, action)=>{
            state.phproductstatusList.unshift(action.payload);
            state.phproductstatusDashboard.phproductstatusList.unshift(action.payload);

            state.phproductstatusDashboard.phproductstatusObj=action.payload;
            state.phproductstatusDashboard.selectedId=action.payload.id;
        },
        updatePhproductstatusObj: (state, action)=>{
            let index = state.phproductstatusList.map(phproductstatusObj=>phproductstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductstatusList[index]=action.payload;
            }

            index = state.phproductstatusDashboard.phproductstatusList.map(phproductstatusObj=>phproductstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductstatusDashboard.phproductstatusList[index]=action.payload;
            }
            if (state.phproductstatusDashboard.phproductstatusObj!==null){
                state.phproductstatusDashboard.phproductstatusObj = action.payload;
            }
        },
        deletePhproductstatusObj: (state, action)=>{
            state.phproductstatusList.splice(state.phproductstatusList.findIndex(a => a.id === action.payload) , 1);
            state.phproductstatusDashboard.phproductstatusList.splice(state.phproductstatusDashboard.phproductstatusList.findIndex(a => a.id === action.payload) , 1);
            state.phproductstatusDashboard.productObj={}
            state.phproductstatusDashboard.selectedId=-1
        },
        setSelectedPhproductstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.phproductstatusDashboard.selectedId=action.payload;
                state.phproductstatusDashboard.phproductstatusObj = state.phproductstatusList[
                    state.phproductstatusList.findIndex(phproductstatusObj=>phproductstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.phproductstatusDashboard.selectedId=action.payload;
                state.phproductstatusDashboard.phproductstatusObj ={}
            }
        },
        setPhproductstatusList: (state, action) =>{
            state.phproductstatusList=action.payload;
            state.phproductstatusDashboard.phproductstatusList=action.payload;
        },
        setPhproductstatusDashboardPhproductstatusList: (state, action) =>{
            state.phproductstatusDashboard.phproductstatusList=action.payload;
        },
        /* Phproductshape Reducer methods */
        setPhproductshapeSorting: (state, action)=>{
            state.phproductshapeDashboard.sorting=action.payload;
        },
        setPhproductshapeFilterCriteria : (state, action)=>{
            state.phproductshapeDashboard.filterCriteria=action.payload;
        },
        setShowEditForPhproductshape: (state,action)=>{
            state.phproductshapeDashboard.showEdit=action.payload;
            
        },
        addPhproductshapeObj: (state, action)=>{
            state.phproductshapeList.unshift(action.payload);
            state.phproductshapeDashboard.phproductshapeList.unshift(action.payload);

            state.phproductshapeDashboard.phproductshapeObj=action.payload;
            state.phproductshapeDashboard.selectedId=action.payload.id;
        },
        updatePhproductshapeObj: (state, action)=>{
            let index = state.phproductshapeList.map(phproductshapeObj=>phproductshapeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductshapeList[index]=action.payload;
            }

            index = state.phproductshapeDashboard.phproductshapeList.map(phproductshapeObj=>phproductshapeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phproductshapeDashboard.phproductshapeList[index]=action.payload;
            }
            if (state.phproductshapeDashboard.phproductshapeObj!==null){
                state.phproductshapeDashboard.phproductshapeObj = action.payload;
            }
        },
        deletePhproductshapeObj: (state, action)=>{
            state.phproductshapeList.splice(state.phproductshapeList.findIndex(a => a.id === action.payload) , 1);
            state.phproductshapeDashboard.phproductshapeList.splice(state.phproductshapeDashboard.phproductshapeList.findIndex(a => a.id === action.payload) , 1);
            state.phproductshapeDashboard.productObj={}
            state.phproductshapeDashboard.selectedId=-1
        },
        setSelectedPhproductshapeId: (state, action)=>{
            if (action.payload!==-1){
                state.phproductshapeDashboard.selectedId=action.payload;
                state.phproductshapeDashboard.phproductshapeObj = state.phproductshapeList[
                    state.phproductshapeList.findIndex(phproductshapeObj=>phproductshapeObj.id===parseInt(action.payload))
            ];
            } else {
                state.phproductshapeDashboard.selectedId=action.payload;
                state.phproductshapeDashboard.phproductshapeObj ={}
            }
        },
        setPhproductshapeList: (state, action) =>{
            state.phproductshapeList=action.payload;
            state.phproductshapeDashboard.phproductshapeList=action.payload;
        },
        setPhproductshapeDashboardPhproductshapeList: (state, action) =>{
            state.phproductshapeDashboard.phproductshapeList=action.payload;
        },
        /* Phdesign Reducer methods */
        setPhdesignSorting: (state, action)=>{
            state.phdesignDashboard.sorting=action.payload;
        },
        setPhdesignFilterCriteria : (state, action)=>{
            state.phdesignDashboard.filterCriteria=action.payload;
        },
        setShowEditForPhdesign: (state,action)=>{
            state.phdesignDashboard.showEdit=action.payload;
            
        },
        addPhdesignObj: (state, action)=>{
            state.phdesignList.unshift(action.payload);
            state.phdesignDashboard.phdesignList.unshift(action.payload);

            state.phdesignDashboard.phdesignObj=action.payload;
            state.phdesignDashboard.selectedId=action.payload.id;
        },
        updatePhdesignObj: (state, action)=>{
            let index = state.phdesignList.map(phdesignObj=>phdesignObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phdesignList[index]=action.payload;
            }

            index = state.phdesignDashboard.phdesignList.map(phdesignObj=>phdesignObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.phdesignDashboard.phdesignList[index]=action.payload;
            }
            if (state.phdesignDashboard.phdesignObj!==null){
                state.phdesignDashboard.phdesignObj = action.payload;
            }
        },
        deletePhdesignObj: (state, action)=>{
            state.phdesignList.splice(state.phdesignList.findIndex(a => a.id === action.payload) , 1);
            state.phdesignDashboard.phdesignList.splice(state.phdesignDashboard.phdesignList.findIndex(a => a.id === action.payload) , 1);
            state.phdesignDashboard.productObj={}
            state.phdesignDashboard.selectedId=-1
        },
        setSelectedPhdesignId: (state, action)=>{
            if (action.payload!==-1){
                state.phdesignDashboard.selectedId=action.payload;
                state.phdesignDashboard.phdesignObj = state.phdesignList[
                    state.phdesignList.findIndex(phdesignObj=>phdesignObj.id===parseInt(action.payload))
            ];
            } else {
                state.phdesignDashboard.selectedId=action.payload;
                state.phdesignDashboard.phdesignObj ={}
            }
        },
        setPhdesignList: (state, action) =>{
            state.phdesignList=action.payload;
            state.phdesignDashboard.phdesignList=action.payload;
        },
        setPhdesignDashboardPhdesignList: (state, action) =>{
            state.phdesignDashboard.phdesignList=action.payload;
        },
        /* Productasset Reducer methods */
        setProductassetSorting: (state, action)=>{
            state.productassetDashboard.sorting=action.payload;
        },
        setProductassetFilterCriteria : (state, action)=>{
            state.productassetDashboard.filterCriteria=action.payload;
        },
        setShowEditForProductasset: (state,action)=>{
            state.productassetDashboard.showEdit=action.payload;
            
			state.productassetDashboard.viewModalOpen=false;
			state.productassetDashboard.AnnotateAssetModalOpen=false;
        },
        addProductassetObj: (state, action)=>{
            state.productassetList.unshift(action.payload);
            state.productassetDashboard.productassetList.unshift(action.payload);

            state.productassetDashboard.productassetObj=action.payload;
            state.productassetDashboard.selectedId=action.payload.id;
        },
        updateProductassetObj: (state, action)=>{
            let index = state.productassetList.map(productassetObj=>productassetObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productassetList[index]=action.payload;
            }

            index = state.productassetDashboard.productassetList.map(productassetObj=>productassetObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productassetDashboard.productassetList[index]=action.payload;
            }
            if (state.productassetDashboard.productassetObj!==null){
                state.productassetDashboard.productassetObj = action.payload;
            }
        },
        deleteProductassetObj: (state, action)=>{
            state.productassetList.splice(state.productassetList.findIndex(a => a.id === action.payload) , 1);
            state.productassetDashboard.productassetList.splice(state.productassetDashboard.productassetList.findIndex(a => a.id === action.payload) , 1);
            state.productassetDashboard.productObj={}
            state.productassetDashboard.selectedId=-1
        },
        setSelectedProductassetId: (state, action)=>{
            if (action.payload!==-1){
                state.productassetDashboard.selectedId=action.payload;
                state.productassetDashboard.productassetObj = state.productassetList[
                    state.productassetList.findIndex(productassetObj=>productassetObj.id===parseInt(action.payload))
            ];
            } else {
                state.productassetDashboard.selectedId=action.payload;
                state.productassetDashboard.productassetObj ={}
            }
        },
        setProductassetList: (state, action) =>{
            state.productassetList=action.payload;
            state.productassetDashboard.productassetList=action.payload;
        },
        setProductassetDashboardProductassetList: (state, action) =>{
            state.productassetDashboard.productassetList=action.payload;
        },
      
        setProductassetViewModal:(state,action)=>{
          state.productassetDashboard.viewModalOpen=action.payload;
        },
      
        setProductassetAnnotateAssetModal:(state,action)=>{
          state.productassetDashboard.AnnotateAssetModalOpen=action.payload;
        },
        /* Rmunit Reducer methods */
        setRmunitSorting: (state, action)=>{
            state.rmunitDashboard.sorting=action.payload;
        },
        setRmunitFilterCriteria : (state, action)=>{
            state.rmunitDashboard.filterCriteria=action.payload;
        },
        setShowEditForRmunit: (state,action)=>{
            state.rmunitDashboard.showEdit=action.payload;
            
        },
        addRmunitObj: (state, action)=>{
            state.rmunitList.unshift(action.payload);
            state.rmunitDashboard.rmunitList.unshift(action.payload);

            state.rmunitDashboard.rmunitObj=action.payload;
            state.rmunitDashboard.selectedId=action.payload.id;
        },
        updateRmunitObj: (state, action)=>{
            let index = state.rmunitList.map(rmunitObj=>rmunitObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmunitList[index]=action.payload;
            }

            index = state.rmunitDashboard.rmunitList.map(rmunitObj=>rmunitObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmunitDashboard.rmunitList[index]=action.payload;
            }
            if (state.rmunitDashboard.rmunitObj!==null){
                state.rmunitDashboard.rmunitObj = action.payload;
            }
        },
        deleteRmunitObj: (state, action)=>{
            state.rmunitList.splice(state.rmunitList.findIndex(a => a.id === action.payload) , 1);
            state.rmunitDashboard.rmunitList.splice(state.rmunitDashboard.rmunitList.findIndex(a => a.id === action.payload) , 1);
            state.rmunitDashboard.productObj={}
            state.rmunitDashboard.selectedId=-1
        },
        setSelectedRmunitId: (state, action)=>{
            if (action.payload!==-1){
                state.rmunitDashboard.selectedId=action.payload;
                state.rmunitDashboard.rmunitObj = state.rmunitList[
                    state.rmunitList.findIndex(rmunitObj=>rmunitObj.id===parseInt(action.payload))
            ];
            } else {
                state.rmunitDashboard.selectedId=action.payload;
                state.rmunitDashboard.rmunitObj ={}
            }
        },
        setRmunitList: (state, action) =>{
            state.rmunitList=action.payload;
            state.rmunitDashboard.rmunitList=action.payload;
        },
        setRmunitDashboardRmunitList: (state, action) =>{
            state.rmunitDashboard.rmunitList=action.payload;
        },
        /* Rawmaterial Reducer methods */
        setRawmaterialSorting: (state, action)=>{
            state.rawmaterialDashboard.sorting=action.payload;
        },
        setRawmaterialFilterCriteria : (state, action)=>{
            state.rawmaterialDashboard.filterCriteria=action.payload;
        },
        setShowEditForRawmaterial: (state,action)=>{
            state.rawmaterialDashboard.showEdit=action.payload;
            
        },
        addRawmaterialObj: (state, action)=>{
            state.rawmaterialList.unshift(action.payload);
            state.rawmaterialDashboard.rawmaterialList.unshift(action.payload);

            state.rawmaterialDashboard.rawmaterialObj=action.payload;
            state.rawmaterialDashboard.selectedId=action.payload.id;
        },
        updateRawmaterialObj: (state, action)=>{
            let index = state.rawmaterialList.map(rawmaterialObj=>rawmaterialObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rawmaterialList[index]=action.payload;
            }

            index = state.rawmaterialDashboard.rawmaterialList.map(rawmaterialObj=>rawmaterialObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rawmaterialDashboard.rawmaterialList[index]=action.payload;
            }
            if (state.rawmaterialDashboard.rawmaterialObj!==null){
                state.rawmaterialDashboard.rawmaterialObj = action.payload;
            }
        },
        deleteRawmaterialObj: (state, action)=>{
            state.rawmaterialList.splice(state.rawmaterialList.findIndex(a => a.id === action.payload) , 1);
            state.rawmaterialDashboard.rawmaterialList.splice(state.rawmaterialDashboard.rawmaterialList.findIndex(a => a.id === action.payload) , 1);
            state.rawmaterialDashboard.productObj={}
            state.rawmaterialDashboard.selectedId=-1
        },
        setSelectedRawmaterialId: (state, action)=>{
            if (action.payload!==-1){
                state.rawmaterialDashboard.selectedId=action.payload;
                state.rawmaterialDashboard.rawmaterialObj = state.rawmaterialList[
                    state.rawmaterialList.findIndex(rawmaterialObj=>rawmaterialObj.id===parseInt(action.payload))
            ];
            } else {
                state.rawmaterialDashboard.selectedId=action.payload;
                state.rawmaterialDashboard.rawmaterialObj ={}
            }
        },
        setRawmaterialList: (state, action) =>{
            state.rawmaterialList=action.payload;
            state.rawmaterialDashboard.rawmaterialList=action.payload;
        },
        setRawmaterialDashboardRawmaterialList: (state, action) =>{
            state.rawmaterialDashboard.rawmaterialList=action.payload;
        },
        /* Productraw Reducer methods */
        setProductrawSorting: (state, action)=>{
            state.productrawDashboard.sorting=action.payload;
        },
        setProductrawFilterCriteria : (state, action)=>{
            state.productrawDashboard.filterCriteria=action.payload;
        },
        setShowEditForProductraw: (state,action)=>{
            state.productrawDashboard.showEdit=action.payload;
            
        },
        addProductrawObj: (state, action)=>{
            state.productrawList.unshift(action.payload);
            state.productrawDashboard.productrawList.unshift(action.payload);

            state.productrawDashboard.productrawObj=action.payload;
            state.productrawDashboard.selectedId=action.payload.id;
        },
        updateProductrawObj: (state, action)=>{
            let index = state.productrawList.map(productrawObj=>productrawObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productrawList[index]=action.payload;
            }

            index = state.productrawDashboard.productrawList.map(productrawObj=>productrawObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productrawDashboard.productrawList[index]=action.payload;
            }
            if (state.productrawDashboard.productrawObj!==null){
                state.productrawDashboard.productrawObj = action.payload;
            }
        },
        deleteProductrawObj: (state, action)=>{
            state.productrawList.splice(state.productrawList.findIndex(a => a.id === action.payload) , 1);
            state.productrawDashboard.productrawList.splice(state.productrawDashboard.productrawList.findIndex(a => a.id === action.payload) , 1);
            state.productrawDashboard.productObj={}
            state.productrawDashboard.selectedId=-1
        },
        setSelectedProductrawId: (state, action)=>{
            if (action.payload!==-1){
                state.productrawDashboard.selectedId=action.payload;
                state.productrawDashboard.productrawObj = state.productrawList[
                    state.productrawList.findIndex(productrawObj=>productrawObj.id===parseInt(action.payload))
            ];
            } else {
                state.productrawDashboard.selectedId=action.payload;
                state.productrawDashboard.productrawObj ={}
            }
        },
        setProductrawList: (state, action) =>{
            state.productrawList=action.payload;
            state.productrawDashboard.productrawList=action.payload;
        },
        setProductrawDashboardProductrawList: (state, action) =>{
            state.productrawDashboard.productrawList=action.payload;
        },
        /* Rawdemand Reducer methods */
        setRawdemandSorting: (state, action)=>{
            state.rawdemandDashboard.sorting=action.payload;
        },
        setRawdemandFilterCriteria : (state, action)=>{
            state.rawdemandDashboard.filterCriteria=action.payload;
        },
        setShowEditForRawdemand: (state,action)=>{
            state.rawdemandDashboard.showEdit=action.payload;
            
			state.rawdemandDashboard.quotationmgmtModalOpen=false;
        },
        addRawdemandObj: (state, action)=>{
            state.rawdemandList.unshift(action.payload);
            state.rawdemandDashboard.rawdemandList.unshift(action.payload);

            state.rawdemandDashboard.rawdemandObj=action.payload;
            state.rawdemandDashboard.selectedId=action.payload.id;
        },
        updateRawdemandObj: (state, action)=>{
            let index = state.rawdemandList.map(rawdemandObj=>rawdemandObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rawdemandList[index]=action.payload;
            }

            index = state.rawdemandDashboard.rawdemandList.map(rawdemandObj=>rawdemandObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rawdemandDashboard.rawdemandList[index]=action.payload;
            }
            if (state.rawdemandDashboard.rawdemandObj!==null){
                state.rawdemandDashboard.rawdemandObj = action.payload;
            }
        },
        deleteRawdemandObj: (state, action)=>{
            state.rawdemandList.splice(state.rawdemandList.findIndex(a => a.id === action.payload) , 1);
            state.rawdemandDashboard.rawdemandList.splice(state.rawdemandDashboard.rawdemandList.findIndex(a => a.id === action.payload) , 1);
            state.rawdemandDashboard.productObj={}
            state.rawdemandDashboard.selectedId=-1
        },
        setSelectedRawdemandId: (state, action)=>{
            if (action.payload!==-1){
                state.rawdemandDashboard.selectedId=action.payload;
                state.rawdemandDashboard.rawdemandObj = state.rawdemandList[
                    state.rawdemandList.findIndex(rawdemandObj=>rawdemandObj.id===parseInt(action.payload))
            ];
            } else {
                state.rawdemandDashboard.selectedId=action.payload;
                state.rawdemandDashboard.rawdemandObj ={}
            }
        },
        setRawdemandList: (state, action) =>{
            state.rawdemandList=action.payload;
            state.rawdemandDashboard.rawdemandList=action.payload;
        },
        setRawdemandDashboardRawdemandList: (state, action) =>{
            state.rawdemandDashboard.rawdemandList=action.payload;
        },
      
        setRawdemandQuotationmgmtModal:(state,action)=>{
          state.rawdemandDashboard.quotationmgmtModalOpen=action.payload;
        },
        /* Productrawtorawdemand Reducer methods */
        setProductrawtorawdemandSorting: (state, action)=>{
            state.productrawtorawdemandDashboard.sorting=action.payload;
        },
        setProductrawtorawdemandFilterCriteria : (state, action)=>{
            state.productrawtorawdemandDashboard.filterCriteria=action.payload;
        },
        setShowEditForProductrawtorawdemand: (state,action)=>{
            state.productrawtorawdemandDashboard.showEdit=action.payload;
            
        },
        addProductrawtorawdemandObj: (state, action)=>{
            state.productrawtorawdemandList.unshift(action.payload);
            state.productrawtorawdemandDashboard.productrawtorawdemandList.unshift(action.payload);

            state.productrawtorawdemandDashboard.productrawtorawdemandObj=action.payload;
            state.productrawtorawdemandDashboard.selectedId=action.payload.id;
        },
        updateProductrawtorawdemandObj: (state, action)=>{
            let index = state.productrawtorawdemandList.map(productrawtorawdemandObj=>productrawtorawdemandObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productrawtorawdemandList[index]=action.payload;
            }

            index = state.productrawtorawdemandDashboard.productrawtorawdemandList.map(productrawtorawdemandObj=>productrawtorawdemandObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.productrawtorawdemandDashboard.productrawtorawdemandList[index]=action.payload;
            }
            if (state.productrawtorawdemandDashboard.productrawtorawdemandObj!==null){
                state.productrawtorawdemandDashboard.productrawtorawdemandObj = action.payload;
            }
        },
        deleteProductrawtorawdemandObj: (state, action)=>{
            state.productrawtorawdemandList.splice(state.productrawtorawdemandList.findIndex(a => a.id === action.payload) , 1);
            state.productrawtorawdemandDashboard.productrawtorawdemandList.splice(state.productrawtorawdemandDashboard.productrawtorawdemandList.findIndex(a => a.id === action.payload) , 1);
            state.productrawtorawdemandDashboard.productObj={}
            state.productrawtorawdemandDashboard.selectedId=-1
        },
        setSelectedProductrawtorawdemandId: (state, action)=>{
            if (action.payload!==-1){
                state.productrawtorawdemandDashboard.selectedId=action.payload;
                state.productrawtorawdemandDashboard.productrawtorawdemandObj = state.productrawtorawdemandList[
                    state.productrawtorawdemandList.findIndex(productrawtorawdemandObj=>productrawtorawdemandObj.id===parseInt(action.payload))
            ];
            } else {
                state.productrawtorawdemandDashboard.selectedId=action.payload;
                state.productrawtorawdemandDashboard.productrawtorawdemandObj ={}
            }
        },
        setProductrawtorawdemandList: (state, action) =>{
            state.productrawtorawdemandList=action.payload;
            state.productrawtorawdemandDashboard.productrawtorawdemandList=action.payload;
        },
        setProductrawtorawdemandDashboardProductrawtorawdemandList: (state, action) =>{
            state.productrawtorawdemandDashboard.productrawtorawdemandList=action.payload;
        },
        /* Rmvendor Reducer methods */
        setRmvendorSorting: (state, action)=>{
            state.rmvendorDashboard.sorting=action.payload;
        },
        setRmvendorFilterCriteria : (state, action)=>{
            state.rmvendorDashboard.filterCriteria=action.payload;
        },
        setShowEditForRmvendor: (state,action)=>{
            state.rmvendorDashboard.showEdit=action.payload;
            
        },
        addRmvendorObj: (state, action)=>{
            state.rmvendorList.unshift(action.payload);
            state.rmvendorDashboard.rmvendorList.unshift(action.payload);

            state.rmvendorDashboard.rmvendorObj=action.payload;
            state.rmvendorDashboard.selectedId=action.payload.id;
        },
        updateRmvendorObj: (state, action)=>{
            let index = state.rmvendorList.map(rmvendorObj=>rmvendorObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmvendorList[index]=action.payload;
            }

            index = state.rmvendorDashboard.rmvendorList.map(rmvendorObj=>rmvendorObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmvendorDashboard.rmvendorList[index]=action.payload;
            }
            if (state.rmvendorDashboard.rmvendorObj!==null){
                state.rmvendorDashboard.rmvendorObj = action.payload;
            }
        },
        deleteRmvendorObj: (state, action)=>{
            state.rmvendorList.splice(state.rmvendorList.findIndex(a => a.id === action.payload) , 1);
            state.rmvendorDashboard.rmvendorList.splice(state.rmvendorDashboard.rmvendorList.findIndex(a => a.id === action.payload) , 1);
            state.rmvendorDashboard.productObj={}
            state.rmvendorDashboard.selectedId=-1
        },
        setSelectedRmvendorId: (state, action)=>{
            if (action.payload!==-1){
                state.rmvendorDashboard.selectedId=action.payload;
                state.rmvendorDashboard.rmvendorObj = state.rmvendorList[
                    state.rmvendorList.findIndex(rmvendorObj=>rmvendorObj.id===parseInt(action.payload))
            ];
            } else {
                state.rmvendorDashboard.selectedId=action.payload;
                state.rmvendorDashboard.rmvendorObj ={}
            }
        },
        setRmvendorList: (state, action) =>{
            state.rmvendorList=action.payload;
            state.rmvendorDashboard.rmvendorList=action.payload;
        },
        setRmvendorDashboardRmvendorList: (state, action) =>{
            state.rmvendorDashboard.rmvendorList=action.payload;
        },
        /* Rmvendorquotation Reducer methods */
        setRmvendorquotationSorting: (state, action)=>{
            state.rmvendorquotationDashboard.sorting=action.payload;
        },
        setRmvendorquotationFilterCriteria : (state, action)=>{
            state.rmvendorquotationDashboard.filterCriteria=action.payload;
        },
        setShowEditForRmvendorquotation: (state,action)=>{
            state.rmvendorquotationDashboard.showEdit=action.payload;
            
        },
        addRmvendorquotationObj: (state, action)=>{
            state.rmvendorquotationList.unshift(action.payload);
            state.rmvendorquotationDashboard.rmvendorquotationList.unshift(action.payload);

            state.rmvendorquotationDashboard.rmvendorquotationObj=action.payload;
            state.rmvendorquotationDashboard.selectedId=action.payload.id;
        },
        updateRmvendorquotationObj: (state, action)=>{
            let index = state.rmvendorquotationList.map(rmvendorquotationObj=>rmvendorquotationObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmvendorquotationList[index]=action.payload;
            }

            index = state.rmvendorquotationDashboard.rmvendorquotationList.map(rmvendorquotationObj=>rmvendorquotationObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmvendorquotationDashboard.rmvendorquotationList[index]=action.payload;
            }
            if (state.rmvendorquotationDashboard.rmvendorquotationObj!==null){
                state.rmvendorquotationDashboard.rmvendorquotationObj = action.payload;
            }
        },
        deleteRmvendorquotationObj: (state, action)=>{
            state.rmvendorquotationList.splice(state.rmvendorquotationList.findIndex(a => a.id === action.payload) , 1);
            state.rmvendorquotationDashboard.rmvendorquotationList.splice(state.rmvendorquotationDashboard.rmvendorquotationList.findIndex(a => a.id === action.payload) , 1);
            state.rmvendorquotationDashboard.productObj={}
            state.rmvendorquotationDashboard.selectedId=-1
        },
        setSelectedRmvendorquotationId: (state, action)=>{
            if (action.payload!==-1){
                state.rmvendorquotationDashboard.selectedId=action.payload;
                state.rmvendorquotationDashboard.rmvendorquotationObj = state.rmvendorquotationList[
                    state.rmvendorquotationList.findIndex(rmvendorquotationObj=>rmvendorquotationObj.id===parseInt(action.payload))
            ];
            } else {
                state.rmvendorquotationDashboard.selectedId=action.payload;
                state.rmvendorquotationDashboard.rmvendorquotationObj ={}
            }
        },
        setRmvendorquotationList: (state, action) =>{
            state.rmvendorquotationList=action.payload;
            state.rmvendorquotationDashboard.rmvendorquotationList=action.payload;
        },
        setRmvendorquotationDashboardRmvendorquotationList: (state, action) =>{
            state.rmvendorquotationDashboard.rmvendorquotationList=action.payload;
        },
        /* Compositiontemplate Reducer methods */
        setCompositiontemplateSorting: (state, action)=>{
            state.compositiontemplateDashboard.sorting=action.payload;
        },
        setCompositiontemplateFilterCriteria : (state, action)=>{
            state.compositiontemplateDashboard.filterCriteria=action.payload;
        },
        setShowEditForCompositiontemplate: (state,action)=>{
            state.compositiontemplateDashboard.showEdit=action.payload;
            
			state.compositiontemplateDashboard.compositionMgmtModalOpen=false;
        },
        addCompositiontemplateObj: (state, action)=>{
            state.compositiontemplateList.unshift(action.payload);
            state.compositiontemplateDashboard.compositiontemplateList.unshift(action.payload);

            state.compositiontemplateDashboard.compositiontemplateObj=action.payload;
            state.compositiontemplateDashboard.selectedId=action.payload.id;
        },
        updateCompositiontemplateObj: (state, action)=>{
            let index = state.compositiontemplateList.map(compositiontemplateObj=>compositiontemplateObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.compositiontemplateList[index]=action.payload;
            }

            index = state.compositiontemplateDashboard.compositiontemplateList.map(compositiontemplateObj=>compositiontemplateObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.compositiontemplateDashboard.compositiontemplateList[index]=action.payload;
            }
            if (state.compositiontemplateDashboard.compositiontemplateObj!==null){
                state.compositiontemplateDashboard.compositiontemplateObj = action.payload;
            }
        },
        deleteCompositiontemplateObj: (state, action)=>{
            state.compositiontemplateList.splice(state.compositiontemplateList.findIndex(a => a.id === action.payload) , 1);
            state.compositiontemplateDashboard.compositiontemplateList.splice(state.compositiontemplateDashboard.compositiontemplateList.findIndex(a => a.id === action.payload) , 1);
            state.compositiontemplateDashboard.productObj={}
            state.compositiontemplateDashboard.selectedId=-1
        },
        setSelectedCompositiontemplateId: (state, action)=>{
            if (action.payload!==-1){
                state.compositiontemplateDashboard.selectedId=action.payload;
                state.compositiontemplateDashboard.compositiontemplateObj = state.compositiontemplateList[
                    state.compositiontemplateList.findIndex(compositiontemplateObj=>compositiontemplateObj.id===parseInt(action.payload))
            ];
            } else {
                state.compositiontemplateDashboard.selectedId=action.payload;
                state.compositiontemplateDashboard.compositiontemplateObj ={}
            }
        },
        setCompositiontemplateList: (state, action) =>{
            state.compositiontemplateList=action.payload;
            state.compositiontemplateDashboard.compositiontemplateList=action.payload;
        },
        setCompositiontemplateDashboardCompositiontemplateList: (state, action) =>{
            state.compositiontemplateDashboard.compositiontemplateList=action.payload;
        },
      
        setCompositiontemplateCompositionMgmtModal:(state,action)=>{
          state.compositiontemplateDashboard.compositionMgmtModalOpen=action.payload;
        },
        /* Ctitem Reducer methods */
        setCtitemSorting: (state, action)=>{
            state.ctitemDashboard.sorting=action.payload;
        },
        setCtitemFilterCriteria : (state, action)=>{
            state.ctitemDashboard.filterCriteria=action.payload;
        },
        setShowEditForCtitem: (state,action)=>{
            state.ctitemDashboard.showEdit=action.payload;
            
        },
        addCtitemObj: (state, action)=>{
            state.ctitemList.unshift(action.payload);
            state.ctitemDashboard.ctitemList.unshift(action.payload);

            state.ctitemDashboard.ctitemObj=action.payload;
            state.ctitemDashboard.selectedId=action.payload.id;
        },
        updateCtitemObj: (state, action)=>{
            let index = state.ctitemList.map(ctitemObj=>ctitemObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.ctitemList[index]=action.payload;
            }

            index = state.ctitemDashboard.ctitemList.map(ctitemObj=>ctitemObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.ctitemDashboard.ctitemList[index]=action.payload;
            }
            if (state.ctitemDashboard.ctitemObj!==null){
                state.ctitemDashboard.ctitemObj = action.payload;
            }
        },
        deleteCtitemObj: (state, action)=>{
            state.ctitemList.splice(state.ctitemList.findIndex(a => a.id === action.payload) , 1);
            state.ctitemDashboard.ctitemList.splice(state.ctitemDashboard.ctitemList.findIndex(a => a.id === action.payload) , 1);
            state.ctitemDashboard.productObj={}
            state.ctitemDashboard.selectedId=-1
        },
        setSelectedCtitemId: (state, action)=>{
            if (action.payload!==-1){
                state.ctitemDashboard.selectedId=action.payload;
                state.ctitemDashboard.ctitemObj = state.ctitemList[
                    state.ctitemList.findIndex(ctitemObj=>ctitemObj.id===parseInt(action.payload))
            ];
            } else {
                state.ctitemDashboard.selectedId=action.payload;
                state.ctitemDashboard.ctitemObj ={}
            }
        },
        setCtitemList: (state, action) =>{
            state.ctitemList=action.payload;
            state.ctitemDashboard.ctitemList=action.payload;
        },
        setCtitemDashboardCtitemList: (state, action) =>{
            state.ctitemDashboard.ctitemList=action.payload;
        },
        /* Packagingsize Reducer methods */
        setPackagingsizeSorting: (state, action)=>{
            state.packagingsizeDashboard.sorting=action.payload;
        },
        setPackagingsizeFilterCriteria : (state, action)=>{
            state.packagingsizeDashboard.filterCriteria=action.payload;
        },
        setShowEditForPackagingsize: (state,action)=>{
            state.packagingsizeDashboard.showEdit=action.payload;
            
        },
        addPackagingsizeObj: (state, action)=>{
            state.packagingsizeList.unshift(action.payload);
            state.packagingsizeDashboard.packagingsizeList.unshift(action.payload);

            state.packagingsizeDashboard.packagingsizeObj=action.payload;
            state.packagingsizeDashboard.selectedId=action.payload.id;
        },
        updatePackagingsizeObj: (state, action)=>{
            let index = state.packagingsizeList.map(packagingsizeObj=>packagingsizeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.packagingsizeList[index]=action.payload;
            }

            index = state.packagingsizeDashboard.packagingsizeList.map(packagingsizeObj=>packagingsizeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.packagingsizeDashboard.packagingsizeList[index]=action.payload;
            }
            if (state.packagingsizeDashboard.packagingsizeObj!==null){
                state.packagingsizeDashboard.packagingsizeObj = action.payload;
            }
        },
        deletePackagingsizeObj: (state, action)=>{
            state.packagingsizeList.splice(state.packagingsizeList.findIndex(a => a.id === action.payload) , 1);
            state.packagingsizeDashboard.packagingsizeList.splice(state.packagingsizeDashboard.packagingsizeList.findIndex(a => a.id === action.payload) , 1);
            state.packagingsizeDashboard.productObj={}
            state.packagingsizeDashboard.selectedId=-1
        },
        setSelectedPackagingsizeId: (state, action)=>{
            if (action.payload!==-1){
                state.packagingsizeDashboard.selectedId=action.payload;
                state.packagingsizeDashboard.packagingsizeObj = state.packagingsizeList[
                    state.packagingsizeList.findIndex(packagingsizeObj=>packagingsizeObj.id===parseInt(action.payload))
            ];
            } else {
                state.packagingsizeDashboard.selectedId=action.payload;
                state.packagingsizeDashboard.packagingsizeObj ={}
            }
        },
        setPackagingsizeList: (state, action) =>{
            state.packagingsizeList=action.payload;
            state.packagingsizeDashboard.packagingsizeList=action.payload;
        },
        setPackagingsizeDashboardPackagingsizeList: (state, action) =>{
            state.packagingsizeDashboard.packagingsizeList=action.payload;
        },
        /* Pharmaset Reducer methods */
        setPharmasetSorting: (state, action)=>{
            state.pharmasetDashboard.sorting=action.payload;
        },
        setPharmasetFilterCriteria : (state, action)=>{
            state.pharmasetDashboard.filterCriteria=action.payload;
        },
        setShowEditForPharmaset: (state,action)=>{
            state.pharmasetDashboard.showEdit=action.payload;
            
        },
        addPharmasetObj: (state, action)=>{
            state.pharmasetList.unshift(action.payload);
            state.pharmasetDashboard.pharmasetList.unshift(action.payload);

            state.pharmasetDashboard.pharmasetObj=action.payload;
            state.pharmasetDashboard.selectedId=action.payload.id;
        },
        updatePharmasetObj: (state, action)=>{
            let index = state.pharmasetList.map(pharmasetObj=>pharmasetObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.pharmasetList[index]=action.payload;
            }

            index = state.pharmasetDashboard.pharmasetList.map(pharmasetObj=>pharmasetObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.pharmasetDashboard.pharmasetList[index]=action.payload;
            }
            if (state.pharmasetDashboard.pharmasetObj!==null){
                state.pharmasetDashboard.pharmasetObj = action.payload;
            }
        },
        deletePharmasetObj: (state, action)=>{
            state.pharmasetList.splice(state.pharmasetList.findIndex(a => a.id === action.payload) , 1);
            state.pharmasetDashboard.pharmasetList.splice(state.pharmasetDashboard.pharmasetList.findIndex(a => a.id === action.payload) , 1);
            state.pharmasetDashboard.productObj={}
            state.pharmasetDashboard.selectedId=-1
        },
        setSelectedPharmasetId: (state, action)=>{
            if (action.payload!==-1){
                state.pharmasetDashboard.selectedId=action.payload;
                state.pharmasetDashboard.pharmasetObj = state.pharmasetList[
                    state.pharmasetList.findIndex(pharmasetObj=>pharmasetObj.id===parseInt(action.payload))
            ];
            } else {
                state.pharmasetDashboard.selectedId=action.payload;
                state.pharmasetDashboard.pharmasetObj ={}
            }
        },
        setPharmasetList: (state, action) =>{
            state.pharmasetList=action.payload;
            state.pharmasetDashboard.pharmasetList=action.payload;
        },
        setPharmasetDashboardPharmasetList: (state, action) =>{
            state.pharmasetDashboard.pharmasetList=action.payload;
        },
        /* Partystatus Reducer methods */
        setPartystatusSorting: (state, action)=>{
            state.partystatusDashboard.sorting=action.payload;
        },
        setPartystatusFilterCriteria : (state, action)=>{
            state.partystatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForPartystatus: (state,action)=>{
            state.partystatusDashboard.showEdit=action.payload;
            
        },
        addPartystatusObj: (state, action)=>{
            state.partystatusList.unshift(action.payload);
            state.partystatusDashboard.partystatusList.unshift(action.payload);

            state.partystatusDashboard.partystatusObj=action.payload;
            state.partystatusDashboard.selectedId=action.payload.id;
        },
        updatePartystatusObj: (state, action)=>{
            let index = state.partystatusList.map(partystatusObj=>partystatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.partystatusList[index]=action.payload;
            }

            index = state.partystatusDashboard.partystatusList.map(partystatusObj=>partystatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.partystatusDashboard.partystatusList[index]=action.payload;
            }
            if (state.partystatusDashboard.partystatusObj!==null){
                state.partystatusDashboard.partystatusObj = action.payload;
            }
        },
        deletePartystatusObj: (state, action)=>{
            state.partystatusList.splice(state.partystatusList.findIndex(a => a.id === action.payload) , 1);
            state.partystatusDashboard.partystatusList.splice(state.partystatusDashboard.partystatusList.findIndex(a => a.id === action.payload) , 1);
            state.partystatusDashboard.productObj={}
            state.partystatusDashboard.selectedId=-1
        },
        setSelectedPartystatusId: (state, action)=>{
            if (action.payload!==-1){
                state.partystatusDashboard.selectedId=action.payload;
                state.partystatusDashboard.partystatusObj = state.partystatusList[
                    state.partystatusList.findIndex(partystatusObj=>partystatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.partystatusDashboard.selectedId=action.payload;
                state.partystatusDashboard.partystatusObj ={}
            }
        },
        setPartystatusList: (state, action) =>{
            state.partystatusList=action.payload;
            state.partystatusDashboard.partystatusList=action.payload;
        },
        setPartystatusDashboardPartystatusList: (state, action) =>{
            state.partystatusDashboard.partystatusList=action.payload;
        },
        /* Assetcomments Reducer methods */
        setAssetcommentsSorting: (state, action)=>{
            state.assetcommentsDashboard.sorting=action.payload;
        },
        setAssetcommentsFilterCriteria : (state, action)=>{
            state.assetcommentsDashboard.filterCriteria=action.payload;
        },
        setShowEditForAssetcomments: (state,action)=>{
            state.assetcommentsDashboard.showEdit=action.payload;
            
        },
        addAssetcommentsObj: (state, action)=>{
            state.assetcommentsList.unshift(action.payload);
            state.assetcommentsDashboard.assetcommentsList.unshift(action.payload);

            state.assetcommentsDashboard.assetcommentsObj=action.payload;
            state.assetcommentsDashboard.selectedId=action.payload.id;
        },
        updateAssetcommentsObj: (state, action)=>{
            let index = state.assetcommentsList.map(assetcommentsObj=>assetcommentsObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.assetcommentsList[index]=action.payload;
            }

            index = state.assetcommentsDashboard.assetcommentsList.map(assetcommentsObj=>assetcommentsObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.assetcommentsDashboard.assetcommentsList[index]=action.payload;
            }
            if (state.assetcommentsDashboard.assetcommentsObj!==null){
                state.assetcommentsDashboard.assetcommentsObj = action.payload;
            }
        },
        deleteAssetcommentsObj: (state, action)=>{
            state.assetcommentsList.splice(state.assetcommentsList.findIndex(a => a.id === action.payload) , 1);
            state.assetcommentsDashboard.assetcommentsList.splice(state.assetcommentsDashboard.assetcommentsList.findIndex(a => a.id === action.payload) , 1);
            state.assetcommentsDashboard.productObj={}
            state.assetcommentsDashboard.selectedId=-1
        },
        setSelectedAssetcommentsId: (state, action)=>{
            if (action.payload!==-1){
                state.assetcommentsDashboard.selectedId=action.payload;
                state.assetcommentsDashboard.assetcommentsObj = state.assetcommentsList[
                    state.assetcommentsList.findIndex(assetcommentsObj=>assetcommentsObj.id===parseInt(action.payload))
            ];
            } else {
                state.assetcommentsDashboard.selectedId=action.payload;
                state.assetcommentsDashboard.assetcommentsObj ={}
            }
        },
        setAssetcommentsList: (state, action) =>{
            state.assetcommentsList=action.payload;
            state.assetcommentsDashboard.assetcommentsList=action.payload;
        },
        setAssetcommentsDashboardAssetcommentsList: (state, action) =>{
            state.assetcommentsDashboard.assetcommentsList=action.payload;
        },
        /* Salt Reducer methods */
        setSaltSorting: (state, action)=>{
            state.saltDashboard.sorting=action.payload;
        },
        setSaltFilterCriteria : (state, action)=>{
            state.saltDashboard.filterCriteria=action.payload;
        },
        setShowEditForSalt: (state,action)=>{
            state.saltDashboard.showEdit=action.payload;
            
			state.saltDashboard.manageSaltModalOpen=false;
        },
        addSaltObj: (state, action)=>{
            state.saltList.unshift(action.payload);
            state.saltDashboard.saltList.unshift(action.payload);

            state.saltDashboard.saltObj=action.payload;
            state.saltDashboard.selectedId=action.payload.id;
        },
        updateSaltObj: (state, action)=>{
            let index = state.saltList.map(saltObj=>saltObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.saltList[index]=action.payload;
            }

            index = state.saltDashboard.saltList.map(saltObj=>saltObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.saltDashboard.saltList[index]=action.payload;
            }
            if (state.saltDashboard.saltObj!==null){
                state.saltDashboard.saltObj = action.payload;
            }
        },
        deleteSaltObj: (state, action)=>{
            state.saltList.splice(state.saltList.findIndex(a => a.id === action.payload) , 1);
            state.saltDashboard.saltList.splice(state.saltDashboard.saltList.findIndex(a => a.id === action.payload) , 1);
            state.saltDashboard.productObj={}
            state.saltDashboard.selectedId=-1
        },
        setSelectedSaltId: (state, action)=>{
            if (action.payload!==-1){
                state.saltDashboard.selectedId=action.payload;
                state.saltDashboard.saltObj = state.saltList[
                    state.saltList.findIndex(saltObj=>saltObj.id===parseInt(action.payload))
            ];
            } else {
                state.saltDashboard.selectedId=action.payload;
                state.saltDashboard.saltObj ={}
            }
        },
        setSaltList: (state, action) =>{
            state.saltList=action.payload;
            state.saltDashboard.saltList=action.payload;
        },
        setSaltDashboardSaltList: (state, action) =>{
            state.saltDashboard.saltList=action.payload;
        },
      
        setSaltManageSaltModal:(state,action)=>{
          state.saltDashboard.manageSaltModalOpen=action.payload;
        },
        /* Salt2comp Reducer methods */
        setSalt2compSorting: (state, action)=>{
            state.salt2compDashboard.sorting=action.payload;
        },
        setSalt2compFilterCriteria : (state, action)=>{
            state.salt2compDashboard.filterCriteria=action.payload;
        },
        setShowEditForSalt2comp: (state,action)=>{
            state.salt2compDashboard.showEdit=action.payload;
            
        },
        addSalt2compObj: (state, action)=>{
            state.salt2compList.unshift(action.payload);
            state.salt2compDashboard.salt2compList.unshift(action.payload);

            state.salt2compDashboard.salt2compObj=action.payload;
            state.salt2compDashboard.selectedId=action.payload.id;
        },
        updateSalt2compObj: (state, action)=>{
            let index = state.salt2compList.map(salt2compObj=>salt2compObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.salt2compList[index]=action.payload;
            }

            index = state.salt2compDashboard.salt2compList.map(salt2compObj=>salt2compObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.salt2compDashboard.salt2compList[index]=action.payload;
            }
            if (state.salt2compDashboard.salt2compObj!==null){
                state.salt2compDashboard.salt2compObj = action.payload;
            }
        },
        deleteSalt2compObj: (state, action)=>{
            state.salt2compList.splice(state.salt2compList.findIndex(a => a.id === action.payload) , 1);
            state.salt2compDashboard.salt2compList.splice(state.salt2compDashboard.salt2compList.findIndex(a => a.id === action.payload) , 1);
            state.salt2compDashboard.productObj={}
            state.salt2compDashboard.selectedId=-1
        },
        setSelectedSalt2compId: (state, action)=>{
            if (action.payload!==-1){
                state.salt2compDashboard.selectedId=action.payload;
                state.salt2compDashboard.salt2compObj = state.salt2compList[
                    state.salt2compList.findIndex(salt2compObj=>salt2compObj.id===parseInt(action.payload))
            ];
            } else {
                state.salt2compDashboard.selectedId=action.payload;
                state.salt2compDashboard.salt2compObj ={}
            }
        },
        setSalt2compList: (state, action) =>{
            state.salt2compList=action.payload;
            state.salt2compDashboard.salt2compList=action.payload;
        },
        setSalt2compDashboardSalt2compList: (state, action) =>{
            state.salt2compDashboard.salt2compList=action.payload;
        },
        /* Pmorder Reducer methods */
        setPmorderSorting: (state, action)=>{
            state.pmorderDashboard.sorting=action.payload;
        },
        setPmorderFilterCriteria : (state, action)=>{
            state.pmorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForPmorder: (state,action)=>{
            state.pmorderDashboard.showEdit=action.payload;
            
        },
        addPmorderObj: (state, action)=>{
            state.pmorderList.unshift(action.payload);
            state.pmorderDashboard.pmorderList.unshift(action.payload);

            state.pmorderDashboard.pmorderObj=action.payload;
            state.pmorderDashboard.selectedId=action.payload.id;
        },
        updatePmorderObj: (state, action)=>{
            let index = state.pmorderList.map(pmorderObj=>pmorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.pmorderList[index]=action.payload;
            }

            index = state.pmorderDashboard.pmorderList.map(pmorderObj=>pmorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.pmorderDashboard.pmorderList[index]=action.payload;
            }
            if (state.pmorderDashboard.pmorderObj!==null){
                state.pmorderDashboard.pmorderObj = action.payload;
            }
        },
        deletePmorderObj: (state, action)=>{
            state.pmorderList.splice(state.pmorderList.findIndex(a => a.id === action.payload) , 1);
            state.pmorderDashboard.pmorderList.splice(state.pmorderDashboard.pmorderList.findIndex(a => a.id === action.payload) , 1);
            state.pmorderDashboard.productObj={}
            state.pmorderDashboard.selectedId=-1
        },
        setSelectedPmorderId: (state, action)=>{
            if (action.payload!==-1){
                state.pmorderDashboard.selectedId=action.payload;
                state.pmorderDashboard.pmorderObj = state.pmorderList[
                    state.pmorderList.findIndex(pmorderObj=>pmorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.pmorderDashboard.selectedId=action.payload;
                state.pmorderDashboard.pmorderObj ={}
            }
        },
        setPmorderList: (state, action) =>{
            state.pmorderList=action.payload;
            state.pmorderDashboard.pmorderList=action.payload;
        },
        setPmorderDashboardPmorderList: (state, action) =>{
            state.pmorderDashboard.pmorderList=action.payload;
        },
        /* Rmorder Reducer methods */
        setRmorderSorting: (state, action)=>{
            state.rmorderDashboard.sorting=action.payload;
        },
        setRmorderFilterCriteria : (state, action)=>{
            state.rmorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForRmorder: (state,action)=>{
            state.rmorderDashboard.showEdit=action.payload;
            
        },
        addRmorderObj: (state, action)=>{
            state.rmorderList.unshift(action.payload);
            state.rmorderDashboard.rmorderList.unshift(action.payload);

            state.rmorderDashboard.rmorderObj=action.payload;
            state.rmorderDashboard.selectedId=action.payload.id;
        },
        updateRmorderObj: (state, action)=>{
            let index = state.rmorderList.map(rmorderObj=>rmorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmorderList[index]=action.payload;
            }

            index = state.rmorderDashboard.rmorderList.map(rmorderObj=>rmorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.rmorderDashboard.rmorderList[index]=action.payload;
            }
            if (state.rmorderDashboard.rmorderObj!==null){
                state.rmorderDashboard.rmorderObj = action.payload;
            }
        },
        deleteRmorderObj: (state, action)=>{
            state.rmorderList.splice(state.rmorderList.findIndex(a => a.id === action.payload) , 1);
            state.rmorderDashboard.rmorderList.splice(state.rmorderDashboard.rmorderList.findIndex(a => a.id === action.payload) , 1);
            state.rmorderDashboard.productObj={}
            state.rmorderDashboard.selectedId=-1
        },
        setSelectedRmorderId: (state, action)=>{
            if (action.payload!==-1){
                state.rmorderDashboard.selectedId=action.payload;
                state.rmorderDashboard.rmorderObj = state.rmorderList[
                    state.rmorderList.findIndex(rmorderObj=>rmorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.rmorderDashboard.selectedId=action.payload;
                state.rmorderDashboard.rmorderObj ={}
            }
        },
        setRmorderList: (state, action) =>{
            state.rmorderList=action.payload;
            state.rmorderDashboard.rmorderList=action.payload;
        },
        setRmorderDashboardRmorderList: (state, action) =>{
            state.rmorderDashboard.rmorderList=action.payload;
        },
        /* Remark Reducer methods */
        setRemarkSorting: (state, action)=>{
            state.remarkDashboard.sorting=action.payload;
        },
        setRemarkFilterCriteria : (state, action)=>{
            state.remarkDashboard.filterCriteria=action.payload;
        },
        setShowEditForRemark: (state,action)=>{
            state.remarkDashboard.showEdit=action.payload;
            
        },
        addRemarkObj: (state, action)=>{
            state.remarkList.unshift(action.payload);
            state.remarkDashboard.remarkList.unshift(action.payload);

            state.remarkDashboard.remarkObj=action.payload;
            state.remarkDashboard.selectedId=action.payload.id;
        },
        updateRemarkObj: (state, action)=>{
            let index = state.remarkList.map(remarkObj=>remarkObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.remarkList[index]=action.payload;
            }

            index = state.remarkDashboard.remarkList.map(remarkObj=>remarkObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.remarkDashboard.remarkList[index]=action.payload;
            }
            if (state.remarkDashboard.remarkObj!==null){
                state.remarkDashboard.remarkObj = action.payload;
            }
        },
        deleteRemarkObj: (state, action)=>{
            state.remarkList.splice(state.remarkList.findIndex(a => a.id === action.payload) , 1);
            state.remarkDashboard.remarkList.splice(state.remarkDashboard.remarkList.findIndex(a => a.id === action.payload) , 1);
            state.remarkDashboard.productObj={}
            state.remarkDashboard.selectedId=-1
        },
        setSelectedRemarkId: (state, action)=>{
            if (action.payload!==-1){
                state.remarkDashboard.selectedId=action.payload;
                state.remarkDashboard.remarkObj = state.remarkList[
                    state.remarkList.findIndex(remarkObj=>remarkObj.id===parseInt(action.payload))
            ];
            } else {
                state.remarkDashboard.selectedId=action.payload;
                state.remarkDashboard.remarkObj ={}
            }
        },
        setRemarkList: (state, action) =>{
            state.remarkList=action.payload;
            state.remarkDashboard.remarkList=action.payload;
        },
        setRemarkDashboardRemarkList: (state, action) =>{
            state.remarkDashboard.remarkList=action.payload;
        },
        /* Gst Reducer methods */
        setGstSorting: (state, action)=>{
            state.gstDashboard.sorting=action.payload;
        },
        setGstFilterCriteria : (state, action)=>{
            state.gstDashboard.filterCriteria=action.payload;
        },
        setShowEditForGst: (state,action)=>{
            state.gstDashboard.showEdit=action.payload;
            
        },
        addGstObj: (state, action)=>{
            state.gstList.unshift(action.payload);
            state.gstDashboard.gstList.unshift(action.payload);

            state.gstDashboard.gstObj=action.payload;
            state.gstDashboard.selectedId=action.payload.id;
        },
        updateGstObj: (state, action)=>{
            let index = state.gstList.map(gstObj=>gstObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.gstList[index]=action.payload;
            }

            index = state.gstDashboard.gstList.map(gstObj=>gstObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.gstDashboard.gstList[index]=action.payload;
            }
            if (state.gstDashboard.gstObj!==null){
                state.gstDashboard.gstObj = action.payload;
            }
        },
        deleteGstObj: (state, action)=>{
            state.gstList.splice(state.gstList.findIndex(a => a.id === action.payload) , 1);
            state.gstDashboard.gstList.splice(state.gstDashboard.gstList.findIndex(a => a.id === action.payload) , 1);
            state.gstDashboard.productObj={}
            state.gstDashboard.selectedId=-1
        },
        setSelectedGstId: (state, action)=>{
            if (action.payload!==-1){
                state.gstDashboard.selectedId=action.payload;
                state.gstDashboard.gstObj = state.gstList[
                    state.gstList.findIndex(gstObj=>gstObj.id===parseInt(action.payload))
            ];
            } else {
                state.gstDashboard.selectedId=action.payload;
                state.gstDashboard.gstObj ={}
            }
        },
        setGstList: (state, action) =>{
            state.gstList=action.payload;
            state.gstDashboard.gstList=action.payload;
        },
        setGstDashboardGstList: (state, action) =>{
            state.gstDashboard.gstList=action.payload;
        },
        /* Dmunit Reducer methods */
        setDmunitSorting: (state, action)=>{
            state.dmunitDashboard.sorting=action.payload;
        },
        setDmunitFilterCriteria : (state, action)=>{
            state.dmunitDashboard.filterCriteria=action.payload;
        },
        setShowEditForDmunit: (state,action)=>{
            state.dmunitDashboard.showEdit=action.payload;
            
        },
        addDmunitObj: (state, action)=>{
            state.dmunitList.unshift(action.payload);
            state.dmunitDashboard.dmunitList.unshift(action.payload);

            state.dmunitDashboard.dmunitObj=action.payload;
            state.dmunitDashboard.selectedId=action.payload.id;
        },
        updateDmunitObj: (state, action)=>{
            let index = state.dmunitList.map(dmunitObj=>dmunitObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.dmunitList[index]=action.payload;
            }

            index = state.dmunitDashboard.dmunitList.map(dmunitObj=>dmunitObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.dmunitDashboard.dmunitList[index]=action.payload;
            }
            if (state.dmunitDashboard.dmunitObj!==null){
                state.dmunitDashboard.dmunitObj = action.payload;
            }
        },
        deleteDmunitObj: (state, action)=>{
            state.dmunitList.splice(state.dmunitList.findIndex(a => a.id === action.payload) , 1);
            state.dmunitDashboard.dmunitList.splice(state.dmunitDashboard.dmunitList.findIndex(a => a.id === action.payload) , 1);
            state.dmunitDashboard.productObj={}
            state.dmunitDashboard.selectedId=-1
        },
        setSelectedDmunitId: (state, action)=>{
            if (action.payload!==-1){
                state.dmunitDashboard.selectedId=action.payload;
                state.dmunitDashboard.dmunitObj = state.dmunitList[
                    state.dmunitList.findIndex(dmunitObj=>dmunitObj.id===parseInt(action.payload))
            ];
            } else {
                state.dmunitDashboard.selectedId=action.payload;
                state.dmunitDashboard.dmunitObj ={}
            }
        },
        setDmunitList: (state, action) =>{
            state.dmunitList=action.payload;
            state.dmunitDashboard.dmunitList=action.payload;
        },
        setDmunitDashboardDmunitList: (state, action) =>{
            state.dmunitDashboard.dmunitList=action.payload;
        },
        /* Foodcomposition Reducer methods */
        setFoodcompositionSorting: (state, action)=>{
            state.foodcompositionDashboard.sorting=action.payload;
        },
        setFoodcompositionFilterCriteria : (state, action)=>{
            state.foodcompositionDashboard.filterCriteria=action.payload;
        },
        setShowEditForFoodcomposition: (state,action)=>{
            state.foodcompositionDashboard.showEdit=action.payload;
            
			state.foodcompositionDashboard.AddFoodCompModalOpen=false;
        },
        addFoodcompositionObj: (state, action)=>{
            state.foodcompositionList.unshift(action.payload);
            state.foodcompositionDashboard.foodcompositionList.unshift(action.payload);

            state.foodcompositionDashboard.foodcompositionObj=action.payload;
            state.foodcompositionDashboard.selectedId=action.payload.id;
        },
        updateFoodcompositionObj: (state, action)=>{
            let index = state.foodcompositionList.map(foodcompositionObj=>foodcompositionObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.foodcompositionList[index]=action.payload;
            }

            index = state.foodcompositionDashboard.foodcompositionList.map(foodcompositionObj=>foodcompositionObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.foodcompositionDashboard.foodcompositionList[index]=action.payload;
            }
            if (state.foodcompositionDashboard.foodcompositionObj!==null){
                state.foodcompositionDashboard.foodcompositionObj = action.payload;
            }
        },
        deleteFoodcompositionObj: (state, action)=>{
            state.foodcompositionList.splice(state.foodcompositionList.findIndex(a => a.id === action.payload) , 1);
            state.foodcompositionDashboard.foodcompositionList.splice(state.foodcompositionDashboard.foodcompositionList.findIndex(a => a.id === action.payload) , 1);
            state.foodcompositionDashboard.productObj={}
            state.foodcompositionDashboard.selectedId=-1
        },
        setSelectedFoodcompositionId: (state, action)=>{
            if (action.payload!==-1){
                state.foodcompositionDashboard.selectedId=action.payload;
                state.foodcompositionDashboard.foodcompositionObj = state.foodcompositionList[
                    state.foodcompositionList.findIndex(foodcompositionObj=>foodcompositionObj.id===parseInt(action.payload))
            ];
            } else {
                state.foodcompositionDashboard.selectedId=action.payload;
                state.foodcompositionDashboard.foodcompositionObj ={}
            }
        },
        setFoodcompositionList: (state, action) =>{
            state.foodcompositionList=action.payload;
            state.foodcompositionDashboard.foodcompositionList=action.payload;
        },
        setFoodcompositionDashboardFoodcompositionList: (state, action) =>{
            state.foodcompositionDashboard.foodcompositionList=action.payload;
        },
      
        setFoodcompositionAddFoodCompModal:(state,action)=>{
          state.foodcompositionDashboard.AddFoodCompModalOpen=action.payload;
        },
        /* Tag Reducer methods */
        setTagSorting: (state, action)=>{
            state.tagDashboard.sorting=action.payload;
        },
        setTagFilterCriteria : (state, action)=>{
            state.tagDashboard.filterCriteria=action.payload;
        },
        setShowEditForTag: (state,action)=>{
            state.tagDashboard.showEdit=action.payload;
            
        },
        addTagObj: (state, action)=>{
            state.tagList.unshift(action.payload);
            state.tagDashboard.tagList.unshift(action.payload);

            state.tagDashboard.tagObj=action.payload;
            state.tagDashboard.selectedId=action.payload.id;
        },
        updateTagObj: (state, action)=>{
            let index = state.tagList.map(tagObj=>tagObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.tagList[index]=action.payload;
            }

            index = state.tagDashboard.tagList.map(tagObj=>tagObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.tagDashboard.tagList[index]=action.payload;
            }
            if (state.tagDashboard.tagObj!==null){
                state.tagDashboard.tagObj = action.payload;
            }
        },
        deleteTagObj: (state, action)=>{
            state.tagList.splice(state.tagList.findIndex(a => a.id === action.payload) , 1);
            state.tagDashboard.tagList.splice(state.tagDashboard.tagList.findIndex(a => a.id === action.payload) , 1);
            state.tagDashboard.productObj={}
            state.tagDashboard.selectedId=-1
        },
        setSelectedTagId: (state, action)=>{
            if (action.payload!==-1){
                state.tagDashboard.selectedId=action.payload;
                state.tagDashboard.tagObj = state.tagList[
                    state.tagList.findIndex(tagObj=>tagObj.id===parseInt(action.payload))
            ];
            } else {
                state.tagDashboard.selectedId=action.payload;
                state.tagDashboard.tagObj ={}
            }
        },
        setTagList: (state, action) =>{
            state.tagList=action.payload;
            state.tagDashboard.tagList=action.payload;
        },
        setTagDashboardTagList: (state, action) =>{
            state.tagDashboard.tagList=action.payload;
        },
        /* Bilty Reducer methods */
        setBiltySorting: (state, action)=>{
            state.biltyDashboard.sorting=action.payload;
        },
        setBiltyFilterCriteria : (state, action)=>{
            state.biltyDashboard.filterCriteria=action.payload;
        },
        setShowEditForBilty: (state,action)=>{
            state.biltyDashboard.showEdit=action.payload;
            
			state.biltyDashboard.AddBiltyModalOpen=false;
			state.biltyDashboard.ManageBiltyModalOpen=false;
        },
        addBiltyObj: (state, action)=>{
            state.biltyList.unshift(action.payload);
            state.biltyDashboard.biltyList.unshift(action.payload);

            state.biltyDashboard.biltyObj=action.payload;
            state.biltyDashboard.selectedId=action.payload.id;
        },
        updateBiltyObj: (state, action)=>{
            let index = state.biltyList.map(biltyObj=>biltyObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.biltyList[index]=action.payload;
            }

            index = state.biltyDashboard.biltyList.map(biltyObj=>biltyObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.biltyDashboard.biltyList[index]=action.payload;
            }
            if (state.biltyDashboard.biltyObj!==null){
                state.biltyDashboard.biltyObj = action.payload;
            }
        },
        deleteBiltyObj: (state, action)=>{
            state.biltyList.splice(state.biltyList.findIndex(a => a.id === action.payload) , 1);
            state.biltyDashboard.biltyList.splice(state.biltyDashboard.biltyList.findIndex(a => a.id === action.payload) , 1);
            state.biltyDashboard.productObj={}
            state.biltyDashboard.selectedId=-1
        },
        setSelectedBiltyId: (state, action)=>{
            if (action.payload!==-1){
                state.biltyDashboard.selectedId=action.payload;
                state.biltyDashboard.biltyObj = state.biltyList[
                    state.biltyList.findIndex(biltyObj=>biltyObj.id===parseInt(action.payload))
            ];
            } else {
                state.biltyDashboard.selectedId=action.payload;
                state.biltyDashboard.biltyObj ={}
            }
        },
        setBiltyList: (state, action) =>{
            state.biltyList=action.payload;
            state.biltyDashboard.biltyList=action.payload;
        },
        setBiltyDashboardBiltyList: (state, action) =>{
            state.biltyDashboard.biltyList=action.payload;
        },
      
        setBiltyAddBiltyModal:(state,action)=>{
          state.biltyDashboard.AddBiltyModalOpen=action.payload;
        },
      
        setBiltyManageBiltyModal:(state,action)=>{
          state.biltyDashboard.ManageBiltyModalOpen=action.payload;
        },
        /* Biltytoproductmap Reducer methods */
        setBiltytoproductmapSorting: (state, action)=>{
            state.biltytoproductmapDashboard.sorting=action.payload;
        },
        setBiltytoproductmapFilterCriteria : (state, action)=>{
            state.biltytoproductmapDashboard.filterCriteria=action.payload;
        },
        setShowEditForBiltytoproductmap: (state,action)=>{
            state.biltytoproductmapDashboard.showEdit=action.payload;
            
        },
        addBiltytoproductmapObj: (state, action)=>{
            state.biltytoproductmapList.unshift(action.payload);
            state.biltytoproductmapDashboard.biltytoproductmapList.unshift(action.payload);

            state.biltytoproductmapDashboard.biltytoproductmapObj=action.payload;
            state.biltytoproductmapDashboard.selectedId=action.payload.id;
        },
        updateBiltytoproductmapObj: (state, action)=>{
            let index = state.biltytoproductmapList.map(biltytoproductmapObj=>biltytoproductmapObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.biltytoproductmapList[index]=action.payload;
            }

            index = state.biltytoproductmapDashboard.biltytoproductmapList.map(biltytoproductmapObj=>biltytoproductmapObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.biltytoproductmapDashboard.biltytoproductmapList[index]=action.payload;
            }
            if (state.biltytoproductmapDashboard.biltytoproductmapObj!==null){
                state.biltytoproductmapDashboard.biltytoproductmapObj = action.payload;
            }
        },
        deleteBiltytoproductmapObj: (state, action)=>{
            state.biltytoproductmapList.splice(state.biltytoproductmapList.findIndex(a => a.id === action.payload) , 1);
            state.biltytoproductmapDashboard.biltytoproductmapList.splice(state.biltytoproductmapDashboard.biltytoproductmapList.findIndex(a => a.id === action.payload) , 1);
            state.biltytoproductmapDashboard.productObj={}
            state.biltytoproductmapDashboard.selectedId=-1
        },
        setSelectedBiltytoproductmapId: (state, action)=>{
            if (action.payload!==-1){
                state.biltytoproductmapDashboard.selectedId=action.payload;
                state.biltytoproductmapDashboard.biltytoproductmapObj = state.biltytoproductmapList[
                    state.biltytoproductmapList.findIndex(biltytoproductmapObj=>biltytoproductmapObj.id===parseInt(action.payload))
            ];
            } else {
                state.biltytoproductmapDashboard.selectedId=action.payload;
                state.biltytoproductmapDashboard.biltytoproductmapObj ={}
            }
        },
        setBiltytoproductmapList: (state, action) =>{
            state.biltytoproductmapList=action.payload;
            state.biltytoproductmapDashboard.biltytoproductmapList=action.payload;
        },
        setBiltytoproductmapDashboardBiltytoproductmapList: (state, action) =>{
            state.biltytoproductmapDashboard.biltytoproductmapList=action.payload;
        },
    }
});
export const { setActionList, setSelectedActionId, setPartySorting,setPartyList,getPartyList,updatePartyObj,addPartyObj,deletePartyObj,
setSelectedPartyId,
setPartyDashboardPartyList,
setShowEditForParty,
setPartyFilterCriteria,
setPartyPartyMgmtModal,
setPartySubmittoapproveModal,
setPartyAddPartyModal,setProductSorting,setProductList,getProductList,updateProductObj,addProductObj,deleteProductObj,
setSelectedProductId,
setProductDashboardProductList,
setShowEditForProduct,
setProductFilterCriteria,
setProductManagecompositionModal,
setProductEditproductModal,
setProductViewproductModal,
setProductDeleteproductModal,
setProductUpdateproductstatusModal,
setProductUpdateproductModal,
setProductUploaddesignModal,
setProductRmmanagementModal,
setProductQaapprovalModal,
setProductDesignPrintingModal,
setProductSelectImageModal,
setProductHandleTaskModal,setCompositionSorting,setCompositionList,getCompositionList,updateCompositionObj,addCompositionObj,deleteCompositionObj,
setSelectedCompositionId,
setCompositionDashboardCompositionList,
setShowEditForComposition,
setCompositionFilterCriteria,setProductcompositionSorting,setProductcompositionList,getProductcompositionList,updateProductcompositionObj,addProductcompositionObj,deleteProductcompositionObj,
setSelectedProductcompositionId,
setProductcompositionDashboardProductcompositionList,
setShowEditForProductcomposition,
setProductcompositionFilterCriteria,setPoSorting,setPoList,getPoList,updatePoObj,addPoObj,deletePoObj,
setSelectedPoId,
setPoDashboardPoList,
setShowEditForPo,
setPoFilterCriteria,
setPoUploadPoModal,
setPoViewPOModal,setOrderpomappingSorting,setOrderpomappingList,getOrderpomappingList,updateOrderpomappingObj,addOrderpomappingObj,deleteOrderpomappingObj,
setSelectedOrderpomappingId,
setOrderpomappingDashboardOrderpomappingList,
setShowEditForOrderpomapping,
setOrderpomappingFilterCriteria,setPharmaorderSorting,setPharmaorderList,getPharmaorderList,updatePharmaorderObj,addPharmaorderObj,deletePharmaorderObj,
setSelectedPharmaorderId,
setPharmaorderDashboardPharmaorderList,
setShowEditForPharmaorder,
setPharmaorderFilterCriteria,
setPharmaorderManageProductsModal,
setPharmaorderEditorderModal,
setPharmaorderDeleteorderModal,
setPharmaorderAddproductModal,
setPharmaorderVieworderModal,
setPharmaorderApproveorderModal,
setPharmaorderSubmitorderModal,
setPharmaorderReferbackModal,
setPharmaorderAddorderModal,
setPharmaorderAccountsApprovalModal,setPhpackagingmaterialSorting,setPhpackagingmaterialList,getPhpackagingmaterialList,updatePhpackagingmaterialObj,addPhpackagingmaterialObj,deletePhpackagingmaterialObj,
setSelectedPhpackagingmaterialId,
setPhpackagingmaterialDashboardPhpackagingmaterialList,
setShowEditForPhpackagingmaterial,
setPhpackagingmaterialFilterCriteria,setDesignvendorSorting,setDesignvendorList,getDesignvendorList,updateDesignvendorObj,addDesignvendorObj,deleteDesignvendorObj,
setSelectedDesignvendorId,
setDesignvendorDashboardDesignvendorList,
setShowEditForDesignvendor,
setDesignvendorFilterCriteria,setPhproductformSorting,setPhproductformList,getPhproductformList,updatePhproductformObj,addPhproductformObj,deletePhproductformObj,
setSelectedPhproductformId,
setPhproductformDashboardPhproductformList,
setShowEditForPhproductform,
setPhproductformFilterCriteria,
setPhproductformManagePackagingMaterialModal,setPhproductSorting,setPhproductList,getPhproductList,updatePhproductObj,addPhproductObj,deletePhproductObj,
setSelectedPhproductId,
setPhproductDashboardPhproductList,
setShowEditForPhproduct,
setPhproductFilterCriteria,setPhproductstatusSorting,setPhproductstatusList,getPhproductstatusList,updatePhproductstatusObj,addPhproductstatusObj,deletePhproductstatusObj,
setSelectedPhproductstatusId,
setPhproductstatusDashboardPhproductstatusList,
setShowEditForPhproductstatus,
setPhproductstatusFilterCriteria,setPhproductshapeSorting,setPhproductshapeList,getPhproductshapeList,updatePhproductshapeObj,addPhproductshapeObj,deletePhproductshapeObj,
setSelectedPhproductshapeId,
setPhproductshapeDashboardPhproductshapeList,
setShowEditForPhproductshape,
setPhproductshapeFilterCriteria,setPhdesignSorting,setPhdesignList,getPhdesignList,updatePhdesignObj,addPhdesignObj,deletePhdesignObj,
setSelectedPhdesignId,
setPhdesignDashboardPhdesignList,
setShowEditForPhdesign,
setPhdesignFilterCriteria,setProductassetSorting,setProductassetList,getProductassetList,updateProductassetObj,addProductassetObj,deleteProductassetObj,
setSelectedProductassetId,
setProductassetDashboardProductassetList,
setShowEditForProductasset,
setProductassetFilterCriteria,
setProductassetViewModal,
setProductassetAnnotateAssetModal,setRmunitSorting,setRmunitList,getRmunitList,updateRmunitObj,addRmunitObj,deleteRmunitObj,
setSelectedRmunitId,
setRmunitDashboardRmunitList,
setShowEditForRmunit,
setRmunitFilterCriteria,setRawmaterialSorting,setRawmaterialList,getRawmaterialList,updateRawmaterialObj,addRawmaterialObj,deleteRawmaterialObj,
setSelectedRawmaterialId,
setRawmaterialDashboardRawmaterialList,
setShowEditForRawmaterial,
setRawmaterialFilterCriteria,setProductrawSorting,setProductrawList,getProductrawList,updateProductrawObj,addProductrawObj,deleteProductrawObj,
setSelectedProductrawId,
setProductrawDashboardProductrawList,
setShowEditForProductraw,
setProductrawFilterCriteria,setRawdemandSorting,setRawdemandList,getRawdemandList,updateRawdemandObj,addRawdemandObj,deleteRawdemandObj,
setSelectedRawdemandId,
setRawdemandDashboardRawdemandList,
setShowEditForRawdemand,
setRawdemandFilterCriteria,
setRawdemandQuotationmgmtModal,setProductrawtorawdemandSorting,setProductrawtorawdemandList,getProductrawtorawdemandList,updateProductrawtorawdemandObj,addProductrawtorawdemandObj,deleteProductrawtorawdemandObj,
setSelectedProductrawtorawdemandId,
setProductrawtorawdemandDashboardProductrawtorawdemandList,
setShowEditForProductrawtorawdemand,
setProductrawtorawdemandFilterCriteria,setRmvendorSorting,setRmvendorList,getRmvendorList,updateRmvendorObj,addRmvendorObj,deleteRmvendorObj,
setSelectedRmvendorId,
setRmvendorDashboardRmvendorList,
setShowEditForRmvendor,
setRmvendorFilterCriteria,setRmvendorquotationSorting,setRmvendorquotationList,getRmvendorquotationList,updateRmvendorquotationObj,addRmvendorquotationObj,deleteRmvendorquotationObj,
setSelectedRmvendorquotationId,
setRmvendorquotationDashboardRmvendorquotationList,
setShowEditForRmvendorquotation,
setRmvendorquotationFilterCriteria,setCompositiontemplateSorting,setCompositiontemplateList,getCompositiontemplateList,updateCompositiontemplateObj,addCompositiontemplateObj,deleteCompositiontemplateObj,
setSelectedCompositiontemplateId,
setCompositiontemplateDashboardCompositiontemplateList,
setShowEditForCompositiontemplate,
setCompositiontemplateFilterCriteria,
setCompositiontemplateCompositionMgmtModal,setCtitemSorting,setCtitemList,getCtitemList,updateCtitemObj,addCtitemObj,deleteCtitemObj,
setSelectedCtitemId,
setCtitemDashboardCtitemList,
setShowEditForCtitem,
setCtitemFilterCriteria,setPackagingsizeSorting,setPackagingsizeList,getPackagingsizeList,updatePackagingsizeObj,addPackagingsizeObj,deletePackagingsizeObj,
setSelectedPackagingsizeId,
setPackagingsizeDashboardPackagingsizeList,
setShowEditForPackagingsize,
setPackagingsizeFilterCriteria,setPharmasetSorting,setPharmasetList,getPharmasetList,updatePharmasetObj,addPharmasetObj,deletePharmasetObj,
setSelectedPharmasetId,
setPharmasetDashboardPharmasetList,
setShowEditForPharmaset,
setPharmasetFilterCriteria,setPartystatusSorting,setPartystatusList,getPartystatusList,updatePartystatusObj,addPartystatusObj,deletePartystatusObj,
setSelectedPartystatusId,
setPartystatusDashboardPartystatusList,
setShowEditForPartystatus,
setPartystatusFilterCriteria,setAssetcommentsSorting,setAssetcommentsList,getAssetcommentsList,updateAssetcommentsObj,addAssetcommentsObj,deleteAssetcommentsObj,
setSelectedAssetcommentsId,
setAssetcommentsDashboardAssetcommentsList,
setShowEditForAssetcomments,
setAssetcommentsFilterCriteria,setSaltSorting,setSaltList,getSaltList,updateSaltObj,addSaltObj,deleteSaltObj,
setSelectedSaltId,
setSaltDashboardSaltList,
setShowEditForSalt,
setSaltFilterCriteria,
setSaltManageSaltModal,setSalt2compSorting,setSalt2compList,getSalt2compList,updateSalt2compObj,addSalt2compObj,deleteSalt2compObj,
setSelectedSalt2compId,
setSalt2compDashboardSalt2compList,
setShowEditForSalt2comp,
setSalt2compFilterCriteria,setPmorderSorting,setPmorderList,getPmorderList,updatePmorderObj,addPmorderObj,deletePmorderObj,
setSelectedPmorderId,
setPmorderDashboardPmorderList,
setShowEditForPmorder,
setPmorderFilterCriteria,setRmorderSorting,setRmorderList,getRmorderList,updateRmorderObj,addRmorderObj,deleteRmorderObj,
setSelectedRmorderId,
setRmorderDashboardRmorderList,
setShowEditForRmorder,
setRmorderFilterCriteria,setRemarkSorting,setRemarkList,getRemarkList,updateRemarkObj,addRemarkObj,deleteRemarkObj,
setSelectedRemarkId,
setRemarkDashboardRemarkList,
setShowEditForRemark,
setRemarkFilterCriteria,setGstSorting,setGstList,getGstList,updateGstObj,addGstObj,deleteGstObj,
setSelectedGstId,
setGstDashboardGstList,
setShowEditForGst,
setGstFilterCriteria,setDmunitSorting,setDmunitList,getDmunitList,updateDmunitObj,addDmunitObj,deleteDmunitObj,
setSelectedDmunitId,
setDmunitDashboardDmunitList,
setShowEditForDmunit,
setDmunitFilterCriteria,setFoodcompositionSorting,setFoodcompositionList,getFoodcompositionList,updateFoodcompositionObj,addFoodcompositionObj,deleteFoodcompositionObj,
setSelectedFoodcompositionId,
setFoodcompositionDashboardFoodcompositionList,
setShowEditForFoodcomposition,
setFoodcompositionFilterCriteria,
setFoodcompositionAddFoodCompModal,setTagSorting,setTagList,getTagList,updateTagObj,addTagObj,deleteTagObj,
setSelectedTagId,
setTagDashboardTagList,
setShowEditForTag,
setTagFilterCriteria,setBiltySorting,setBiltyList,getBiltyList,updateBiltyObj,addBiltyObj,deleteBiltyObj,
setSelectedBiltyId,
setBiltyDashboardBiltyList,
setShowEditForBilty,
setBiltyFilterCriteria,
setBiltyAddBiltyModal,
setBiltyManageBiltyModal,setBiltytoproductmapSorting,setBiltytoproductmapList,getBiltytoproductmapList,updateBiltytoproductmapObj,addBiltytoproductmapObj,deleteBiltytoproductmapObj,
setSelectedBiltytoproductmapId,
setBiltytoproductmapDashboardBiltytoproductmapList,
setShowEditForBiltytoproductmap,
setBiltytoproductmapFilterCriteria, } = PharmaSlice.actions;
export default PharmaSlice.reducer;